import React, { useEffect, useState } from "react";
import API from "../../api/Createapi";
import "./Adminpage.css";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import Loader from "../Loader";
import RegisterModal from "../auth/RegisterModal";
import { Eye, EyeOff } from "lucide-react";

function Adminpage() {
    const [showRegisterModal, setShowRegisterModal] = useState(false);
    const [activeTab, setActiveTab] = useState("requests");

    const [users, setUsers] = useState([]);
    const [payments, setPayments] = useState([]);
    const [paymentTab, setPaymentTab] = useState("pending");
    const [activatingPlanId, setActivatingPlanId] = useState(null);

    /*
     * Broadband payment status for the users displayed in the
     * Existing Users table.
     *
     * Key:
     *     username
     *
     * Value:
     *     latest successful broadband payment returned by
     *     getUserBroadbandPaymentStatuses.php
     */
    const [broadbandPaymentStatuses, setBroadbandPaymentStatuses] =
        useState({});
    const [broadbandPaymentStatusLoading, setBroadbandPaymentStatusLoading] =
        useState(false);

    const [search, setSearch] = useState("");
    const [filter, setFilter] = useState("");
    const [page, setPage] = useState(1);

    const [pendingPlanType, setPendingPlanType] = useState("BROADBAND");
    const [activePlanType, setActivePlanType] = useState("BROADBAND");
    const [expiredPlanType, setExpiredPlanType] = useState("BROADBAND");
    const [scheduledPlanType, setScheduledPlanType] = useState("BROADBAND");

    const [pendingDateFilter, setPendingDateFilter] = useState("week");
    const [activeDateFilter, setActiveDateFilter] = useState("week");
    const [expiredDateFilter, setExpiredDateFilter] = useState("week");
    const [scheduledDateFilter, setScheduledDateFilter] = useState("week");

    const [roleChanges, setRoleChanges] = useState({});
    const [loading, setLoading] = useState(false);
    const [ottSaving, setOttSaving] = useState(false);
    const [initialLoadComplete, setInitialLoadComplete] = useState(false);

    /* =========================
       PLAN MANAGEMENT STATES
    ========================= */

    const [planTab, setPlanTab] = useState("broadband");

    const [broadbandPlans, setBroadbandPlans] = useState([]);
    const [ottPlatforms, setOttPlatforms] = useState([]);
    const [ottAddonPlans, setOttAddonPlans] = useState([]);

    const [planSearch, setPlanSearch] = useState("");
    const [planStatusFilter, setPlanStatusFilter] = useState("all");

    const [showPlanModal, setShowPlanModal] = useState(false);
    const [showOttModal, setShowOttModal] = useState(false);
    const [showAddonModal, setShowAddonModal] = useState(false);
    const [showOttAssignmentModal, setShowOttAssignmentModal] = useState(false);

    const [editingPlan, setEditingPlan] = useState(null);
    const [editingOtt, setEditingOtt] = useState(null);
    const [editingAddon, setEditingAddon] = useState(null);

    const [selectedDuration, setSelectedDuration] = useState(null);
    const [selectedPlanForOtt, setSelectedPlanForOtt] = useState(null);

    const [selectedOttIds, setSelectedOttIds] = useState([]);
    const [ottLoading, setOttLoading] = useState(false);
    const [ottLogoPreview, setOttLogoPreview] = useState("");

    /* =========================
       OTT ADD-ON ASSIGNMENT STATES
    ========================= */

    const [showAddonOttAssignmentModal, setShowAddonOttAssignmentModal] = useState(false);
    const [selectedAddonForOtt, setSelectedAddonForOtt] = useState(null);
    const [selectedAddonOttIds, setSelectedAddonOttIds] = useState([]);
    const [addonOttLoading, setAddonOttLoading] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const [editingUser, setEditingUser] = useState(null);

    // const [editForm, setEditForm] = useState({
    //     id: "",
    //     fullname: "",
    //     username: "",
    //     email: "",
    //     mobile: "",
    //     city: "",
    //     address: "",
    //     pincode: ""
    // });
    const [editForm, setEditForm] = useState({
        id: "",
        fullname: "",
        username: "",
        email: "",
        password: "",
        mobile: "",
        city: "",
        address: "",
        pincode: ""
    });

    const [updatingUser, setUpdatingUser] = useState(false);

    // const handleEditUser = (user) => {

    //     setEditingUser(user);

    //     setEditForm({
    //         id: user.id,
    //         fullname: user.fullname || "",
    //         username: user.username || "",
    //         email: user.email || "",
    //         mobile: user.mobile || "",
    //         city: user.city || "",
    //         address: user.address || "",
    //         pincode: user.pincode || ""
    //     });

    //     setShowEditModal(true);
    // };
    const handleEditUser = (user) => {

        setEditingUser(user);

        setEditForm({
            id: user.id,
            fullname: user.fullname || "",
            username: user.username || "",
            email: user.email || "",

            // Password must always start empty
            password: "",

            mobile: user.mobile || "",
            city: user.city || "",
            address: user.address || "",
            pincode: user.pincode || ""
        });

        setShowEditModal(true);
    };
    const handleEditChange = (e) => {

        const {
            name,
            value
        } = e.target;

        setEditForm(prev => ({
            ...prev,
            [name]: value
        }));

    };

    // const handleUpdateUser = async (e) => {

    //     e.preventDefault();

    //     if (!editForm.fullname.trim()) {

    //         toast.error("Full name is required");
    //         return;

    //     }

    //     if (!editForm.username.trim()) {

    //         toast.error("Username is required");
    //         return;

    //     }

    //     if (!editForm.email.trim()) {

    //         toast.error("Email is required");
    //         return;

    //     }

    //     setUpdatingUser(true);

    //     try {

    //         const response = await API.post(
    //             "/update_user.php",
    //             {
    //                 id: editForm.id,
    //                 fullname: editForm.fullname.trim(),
    //                 username: editForm.username.trim(),
    //                 email: editForm.email.trim(),
    //                 mobile: editForm.mobile.trim(),
    //                 city: editForm.city.trim(),
    //                 address: editForm.address.trim(),
    //                 pincode: editForm.pincode.trim()
    //             }
    //         );


    //         if (
    //             response.data.status ===
    //             "success"
    //         ) {

    //             toast.success(
    //                 "User details updated successfully"
    //             );

    //             setShowEditModal(false);

    //             setEditingUser(null);

    //             /*
    //              * IMPORTANT:
    //              * Reload the existing user list here.
    //              *
    //              * Replace fetchUsers() with the function
    //              * you already use to load your users.
    //              */

    //             await fetchData();

    //             return;

    //         }


    //         if (
    //             response.data.status ===
    //             "exists"
    //         ) {

    //             toast.error(
    //                 response.data.message
    //             );

    //             return;

    //         }


    //         toast.error(
    //             response.data.message ||
    //             "Failed to update user"
    //         );


    //     } catch (error) {

    //         console.error(
    //             "Update user error:",
    //             error
    //         );

    //         toast.error(
    //             error?.response?.data?.message ||
    //             "Unable to update user"
    //         );

    //     } finally {

    //         setUpdatingUser(false);

    //     }

    // };
    const handleUpdateUser = async (e) => {

        e.preventDefault();

        if (!editForm.fullname.trim()) {

            toast.error("Full name is required");

            return;
        }


        if (!editForm.username.trim()) {

            toast.error("Username is required");

            return;
        }


        if (!editForm.email.trim()) {

            toast.error("Email is required");

            return;
        }


        /*
         * Password is optional while editing.
         *
         * If entered, it must be at least 6 characters.
         */
        if (
            editForm.password &&
            editForm.password.trim().length < 6
        ) {

            toast.error(
                "Password must be at least 6 characters"
            );

            return;
        }


        setUpdatingUser(true);


        try {

            const response = await API.post(
                "/update_user.php",
                {
                    id: editForm.id,

                    fullname:
                        editForm.fullname.trim(),

                    username:
                        editForm.username.trim(),

                    email:
                        editForm.email.trim(),

                    password:
                        editForm.password.trim(),

                    mobile:
                        editForm.mobile.trim(),

                    city:
                        editForm.city.trim(),

                    address:
                        editForm.address.trim(),

                    pincode:
                        editForm.pincode.trim()
                }
            );


            if (
                response.data.status ===
                "success"
            ) {

                if (
                    response.data.email_sent
                ) {

                    toast.success(
                        "User updated and login details sent to email"
                    );

                } else if (
                    editForm.password.trim() !== ""
                ) {

                    toast.warning(
                        "User updated, but email could not be sent"
                    );

                } else {

                    toast.success(
                        "User details updated successfully"
                    );

                }


                /*
                 * Clear password from frontend state.
                 */
                setEditForm(prev => ({
                    ...prev,
                    password: ""
                }));


                setShowEditModal(false);

                setEditingUser(null);


                /*
                 * Reload existing users.
                 */
                await fetchData();

                return;
            }


            if (
                response.data.status ===
                "exists"
            ) {

                toast.error(
                    response.data.message
                );

                return;
            }


            toast.error(
                response.data.message ||
                "Failed to update user"
            );


        } catch (error) {

            console.error(
                "Update user error:",
                error
            );


            toast.error(
                error?.response?.data?.message ||
                "Unable to update user"
            );


        } finally {

            setUpdatingUser(false);
        }

    };
    const [stats, setStats] = useState({
        pending_requests: 0,
        total_existing_users: 0,
        active_users: 0,
        inactive_users: 0,
        payments_today_completed: 0,
        active_plans: 0,
        expired_plans: 0
    });

    /* =========================
       FORM STATES
    ========================= */

    const emptyPlan = {
        plan_name: "",
        speed: "",
        tagline: "",
        is_popular: false,
        display_order: 0,
        active: true,
        durations: [
            {
                months: 1,
                duration_label: "1 Month",
                price: "",
                badge: "",
                active: true,
                display_order: 1
            }
        ],
        features: [""]
    };

    // const emptyOtt = {
    //     ott_name: "",
    //     logo: "",
    //     display_order: 0,
    //     active: true
    // };
    const emptyOtt = {
        ott_name: "",
        logo: "",
        logo_file: null,
        display_order: 0,
        active: true
    };

    const emptyAddon = {
        duration_months: 3,
        duration_label: "3 Months",
        price: "",
        is_popular: false,
        badge: "",
        description: "",
        display_order: 0,
        active: true,
        features: [""]
    };

    const [planForm, setPlanForm] = useState(emptyPlan);
    const [ottForm, setOttForm] = useState(emptyOtt);
    const [addonForm, setAddonForm] = useState(emptyAddon);

    /* =========================
       VALIDATION ERROR STATES
    ========================= */

    const [planErrors, setPlanErrors] = useState({});
    // durationErrors[index] = { price: true, months: true, ... }
    const [durationErrors, setDurationErrors] = useState([]);
    const [ottErrors, setOttErrors] = useState({});
    const [addonErrors, setAddonErrors] = useState({});

    const clearPlanErrors = () => {
        setPlanErrors({});
        setDurationErrors([]);
    };
    const clearOttErrors = () => setOttErrors({});
    const clearAddonErrors = () => setAddonErrors({});

    /* =========================
       DATE / TIMEZONE
    =========================

       MySQL/PHP DATETIME values such as:

           2026-08-15 12:43:18

       do not contain timezone information.

       Treat timezone-less backend DATETIME values as
       Asia/Kolkata (IST) instead of allowing the browser
       timezone to interpret them differently.

       Date-only values such as YYYY-MM-DD are handled
       separately so they never shift to the previous day.
    ========================= */

    const INDIA_TIMEZONE = "Asia/Kolkata";
    const INDIA_OFFSET_MINUTES = 330;

    const parseIndiaDateTime = (value) => {
        if (!value) {
            return null;
        }

        if (value instanceof Date) {
            return Number.isNaN(value.getTime())
                ? null
                : value;
        }

        const raw = String(value).trim();

        if (!raw) {
            return null;
        }

        /*
         * If the backend explicitly provides a timezone,
         * respect the supplied timezone.
         *
         * Examples:
         *   2026-08-15T12:43:18+05:30
         *   2026-08-15T07:13:18Z
         */
        if (/(?:Z|[+-]\d{2}:\d{2})$/i.test(raw)) {
            const explicitDate = new Date(raw);

            return Number.isNaN(explicitDate.getTime())
                ? null
                : explicitDate;
        }

        /*
         * MySQL DATETIME:
         *
         *   YYYY-MM-DD HH:mm:ss
         *   YYYY-MM-DDTHH:mm:ss
         *
         * Interpret these values as IST.
         */
        const match = raw.match(
            /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2})(?:\.(\d+))?)?)?$/
        );

        if (match) {
            const year = Number(match[1]);
            const month = Number(match[2]);
            const day = Number(match[3]);
            const hour = Number(match[4] || 0);
            const minute = Number(match[5] || 0);
            const second = Number(match[6] || 0);

            const milliseconds = Number(
                (match[7] || "0")
                    .padEnd(3, "0")
                    .slice(0, 3)
            );

            const utcMillis =
                Date.UTC(
                    year,
                    month - 1,
                    day,
                    hour,
                    minute,
                    second,
                    milliseconds
                ) -
                INDIA_OFFSET_MINUTES * 60 * 1000;

            const parsedDate = new Date(utcMillis);

            return Number.isNaN(parsedDate.getTime())
                ? null
                : parsedDate;
        }

        const fallbackDate = new Date(raw);

        return Number.isNaN(fallbackDate.getTime())
            ? null
            : fallbackDate;
    };

    const formatDate = (dateString) => {
        if (!dateString) return "N/A";

        const raw = String(dateString).trim();

        /*
         * Already formatted DD-MM-YYYY.
         */
        if (/^\d{2}-\d{2}-\d{4}$/.test(raw)) {
            return raw;
        }

        /*
         * Date-only value from MySQL/PHP.
         *
         * Do not use new Date("YYYY-MM-DD") here because
         * JavaScript treats it as UTC and it can shift the
         * displayed date depending on the browser timezone.
         */
        const dateOnlyMatch = raw.match(
            /^(\d{4})-(\d{2})-(\d{2})$/
        );

        if (dateOnlyMatch) {
            return `${dateOnlyMatch[3]}-${dateOnlyMatch[2]}-${dateOnlyMatch[1]}`;
        }

        const date = parseIndiaDateTime(raw);

        if (!date) {
            return raw;
        }

        /*
         * Always format using Asia/Kolkata.
         */
        const parts = new Intl.DateTimeFormat("en-GB", {
            timeZone: INDIA_TIMEZONE,
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
        }).formatToParts(date);

        const day = parts.find(
            (part) => part.type === "day"
        )?.value;

        const month = parts.find(
            (part) => part.type === "month"
        )?.value;

        const year = parts.find(
            (part) => part.type === "year"
        )?.value;

        if (!day || !month || !year) {
            return raw;
        }

        return `${day}-${month}-${year}`;
    };

    const getRegistrationState = (user) => {
        return user.registration_status || "not_sent";
    };

    const getRegistrationStateLabel = (state) => {
        switch (state) {
            case "completed":
                return "Registration Complete";
            case "expired":
                return "Link Expired";
            case "sent":
                return "Link Sent";
            default:
                return "Not Sent";
        }
    };

    /* =========================================================
       DASHBOARD STATS
       ========================================================= */

    const DEFAULT_STATS = {
        pending_requests: 0,
        total_existing_users: 0,
        active_users: 0,
        inactive_users: 0,
        payments_today_completed: 0,
        active_plans: 0,
        expired_plans: 0
    };

    const normalizeStatNumber = (value) => {
        const number = Number(value);

        return Number.isFinite(number)
            ? number
            : 0;
    };

    const fetchDashboardStats = async () => {
        try {
            console.log(
                "Loading dashboard statistics..."
            );

            const response = await API.get(
                "/get_dashboard_stats.php",
                {
                    headers: {
                        Accept: "application/json"
                    }
                }
            );

            console.log(
                "Dashboard Stats API Response:",
                response?.data
            );

            const apiResponse =
                response?.data || {};

            const apiStatus =
                String(
                    apiResponse?.status || ""
                )
                    .trim()
                    .toLowerCase();

            /*
             * Support the normal response:
             *
             * {
             *   status: "success",
             *   data: { ... }
             * }
             *
             * Also support an accidental "stats" wrapper.
             */
            const rawStats =
                apiResponse?.data ||
                apiResponse?.stats ||
                {};

            if (apiStatus !== "success") {
                console.error(
                    "Dashboard Stats API returned an error:",
                    apiResponse
                );

                setStats(DEFAULT_STATS);

                return false;
            }

            const normalizedStats = {
                pending_requests:
                    normalizeStatNumber(
                        rawStats.pending_requests ??
                        rawStats.pendingRequests ??
                        rawStats.pending_request_count ??
                        rawStats.pending
                    ),

                total_existing_users:
                    normalizeStatNumber(
                        rawStats.total_existing_users ??
                        rawStats.totalExistingUsers ??
                        rawStats.total_users ??
                        rawStats.existing_users ??
                        rawStats.users
                    ),

                active_users:
                    normalizeStatNumber(
                        rawStats.active_users ??
                        rawStats.activeUsers ??
                        rawStats.active_connection_lines ??
                        rawStats.active_connections
                    ),

                inactive_users:
                    normalizeStatNumber(
                        rawStats.inactive_users ??
                        rawStats.inactiveUsers ??
                        rawStats.inactive_connections
                    ),

                payments_today_completed:
                    normalizeStatNumber(
                        rawStats.payments_today_completed ??
                        rawStats.paymentsTodayCompleted ??
                        rawStats.today_completed_payments
                    ),

                active_plans:
                    normalizeStatNumber(
                        rawStats.active_plans ??
                        rawStats.activePlans
                    ),

                expired_plans:
                    normalizeStatNumber(
                        rawStats.expired_plans ??
                        rawStats.expiredPlans
                    )
            };

            console.log(
                "Normalized Dashboard Stats:",
                normalizedStats
            );

            setStats(normalizedStats);

            return true;

        } catch (error) {

            console.error(
                "Dashboard Stats Fetch Error:",
                error
            );

            console.error(
                "Dashboard Stats Error Response:",
                error?.response?.data
            );

            setStats(DEFAULT_STATS);

            return false;
        }
    };

    /* =========================================================
       BROADBAND PAYMENT STATUS API
       =========================================================

       This API requires a username:

           getUserBroadbandPaymentStatuses.php?username=USERNAME

       Therefore the Admin page loads the status for the users
       currently visible in the Existing Users table.

       The API already returns successful BROADBAND payments
       ordered by transaction_date DESC and id DESC, so the
       first record for a username is the latest payment.
    ========================================================= */

    const fetchBroadbandPaymentStatuses = async (
        userList = []
    ) => {

        if (!Array.isArray(userList) || userList.length === 0) {

            setBroadbandPaymentStatuses({});

            return;

        }

        const validUsers = userList.filter(
            (user) =>
                String(user?.username || "").trim() !== ""
        );

        if (validUsers.length === 0) {

            setBroadbandPaymentStatuses({});

            return;

        }

        try {

            setBroadbandPaymentStatusLoading(true);

            const uniqueUsers = [
                ...new Map(
                    validUsers.map((user) => [
                        String(user.username)
                            .trim()
                            .toLowerCase(),
                        user
                    ])
                ).values()
            ];

            const results = await Promise.all(
                uniqueUsers.map(async (user) => {

                    const username =
                        String(user.username).trim();

                    try {

                        const response = await API.get(
                            `/getUserBroadbandPaymentStatuses.php?username=${encodeURIComponent(
                                username
                            )}`,
                            {
                                headers: {
                                    Accept:
                                        "application/json",
                                    "Cache-Control":
                                        "no-cache"
                                },
                                params: {
                                    _ts: Date.now()
                                }
                            }
                        );

                        const status =
                            String(
                                response?.data?.status ||
                                ""
                            )
                                .trim()
                                .toLowerCase();

                        const records =
                            status === "success" &&
                                Array.isArray(
                                    response?.data?.data
                                )
                                ? response.data.data
                                : [];

                        /*
                         * The API orders newest payment first.
                         * Keep the first successful broadband payment.
                         */
                        const latestPayment =
                            records.length > 0
                                ? records[0]
                                : null;

                        return {
                            username,
                            latestPayment
                        };

                    } catch (error) {

                        console.error(
                            `Broadband payment status error for ${username}:`,
                            error
                        );

                        return {
                            username,
                            latestPayment: null
                        };

                    }

                })
            );

            const statusMap = {};

            results.forEach(
                ({
                    username,
                    latestPayment
                }) => {

                    statusMap[
                        String(username)
                            .trim()
                            .toLowerCase()
                    ] = latestPayment;

                }
            );

            setBroadbandPaymentStatuses(
                statusMap
            );

        } catch (error) {

            console.error(
                "Broadband Payment Status Fetch Error:",
                error
            );

            setBroadbandPaymentStatuses({});

        } finally {

            setBroadbandPaymentStatusLoading(false);

        }

    };

    const getBroadbandPaymentStatus = (
        username
    ) => {

        const key =
            String(username || "")
                .trim()
                .toLowerCase();

        if (!key) {
            return null;
        }

        return (
            broadbandPaymentStatuses[key] ||
            null
        );

    };

    const getBroadbandPaymentStatusLabel = (
        username
    ) => {

        const payment =
            getBroadbandPaymentStatus(
                username
            );

        if (!payment) {

            return {
                label: "No Payment",
                className: "pending",
                icon: "fa-minus-circle",
                planName: "",
                expiryDate: ""
            };

        }

        const paymentStatus =
            String(
                payment.payment_status || ""
            )
                .trim()
                .toUpperCase();

        const planStatus =
            String(
                payment.plan_status || ""
            )
                .trim()
                .toUpperCase();

        if (
            paymentStatus === "SUCCESS" &&
            planStatus === "ACTIVE"
        ) {

            return {
                label: "Active",
                className: "active",
                icon: "fa-circle-check",
                planName:
                    payment.plan_name || "",
                expiryDate:
                    payment.plan_expiry_date || ""
            };

        }

        if (
            paymentStatus === "SUCCESS" &&
            planStatus === "EXPIRED"
        ) {

            return {
                label: "Expired",
                className: "expired",
                icon: "fa-circle-exclamation",
                planName:
                    payment.plan_name || "",
                expiryDate:
                    payment.plan_expiry_date || ""
            };

        }

        if (
            paymentStatus === "SUCCESS" &&
            (
                planStatus === "PENDING" ||
                planStatus === ""
            )
        ) {

            return {
                label: "Awaiting Activation",
                className: "pending",
                icon: "fa-clock",
                planName:
                    payment.plan_name || "",
                expiryDate:
                    payment.plan_expiry_date || ""
            };

        }

        if (
            paymentStatus === "SUCCESS"
        ) {

            return {
                label: "Payment Successful",
                className: "success",
                icon: "fa-circle-check",
                planName:
                    payment.plan_name || "",
                expiryDate:
                    payment.plan_expiry_date || ""
            };

        }

        return {
            label:
                paymentStatus ||
                "No Payment",
            className: "pending",
            icon: "fa-clock",
            planName:
                payment.plan_name || "",
            expiryDate:
                payment.plan_expiry_date || ""
        };

    };

    const renderBroadbandPaymentStatus = (
        username
    ) => {

        const payment =
            getBroadbandPaymentStatus(
                username
            );

        if (
            broadbandPaymentStatusLoading &&
            !payment
        ) {

            return (
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "4px",
                        minWidth: "150px"
                    }}
                >
                    <span
                        className="payment-badge pending"
                    >
                        <span className="badge-dot"></span>
                        <i className="fa-solid fa-spinner fa-spin"></i>
                        Loading...
                    </span>
                </div>
            );

        }

        const status =
            getBroadbandPaymentStatusLabel(
                username
            );

        const badgeClass =
            status.className === "active"
                ? "plan-badge active"
                : status.className === "expired"
                    ? "plan-badge expired"
                    : status.className === "success"
                        ? "payment-badge success"
                        : "payment-badge pending";

        return (
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "4px",
                    minWidth: "150px"
                }}
            >

                <span
                    className={badgeClass}
                >
                    <span className="badge-dot"></span>

                    <i
                        className={`fa-solid ${status.icon}`}
                    ></i>

                    {status.label}
                </span>

                {status.planName && (
                    <small
                        style={{
                            color: "#64748b",
                            fontSize: "11px",
                            fontWeight: "600",
                            maxWidth: "180px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap"
                        }}
                        title={status.planName}
                    >
                        {status.planName}
                    </small>
                )}

                {status.expiryDate &&
                    status.className ===
                    "active" && (
                        <small
                            style={{
                                color: "#64748b",
                                fontSize: "10px",
                                fontWeight: "600"
                            }}
                        >
                            Expires:{" "}
                            {formatDate(
                                status.expiryDate
                            )}
                        </small>
                    )}

            </div>
        );

    };

    /* =========================
       NORMAL ADMIN DATA
    ========================= */
    const [pagination, setPagination] = useState({
        page: 1,
        total: 0,
        total_pages: 1
    });
    const fetchData = async (
        showLoader = true,
        overrideTab = null,
        overridePaymentTab = null,
        overridePage = null
    ) => {

        const resolvedTab = overrideTab ?? activeTab;
        const resolvedPaymentTab = overridePaymentTab ?? paymentTab;
        const resolvedPage = overridePage ?? page;

        if (resolvedTab === "plans") {
            return;
        }

        try {
            if (showLoader) {
                setLoading(true);
            }

            let url = "";

            if (resolvedTab === "requests") {
                url = `/get_request_users.php?search=${encodeURIComponent(
                    search
                )}&filter=${encodeURIComponent(filter)}&page=${resolvedPage}`;
            } else if (resolvedTab === "existing") {
                url = `/get_users.php?status=${encodeURIComponent(
                    filter
                )}&search=${encodeURIComponent(search)}&page=${resolvedPage}`;
            } else if (resolvedTab === "payments") {
                let selectedType = "BROADBAND";
                if (resolvedPaymentTab === "pending") selectedType = pendingPlanType;
                else if (resolvedPaymentTab === "active") selectedType = activePlanType;
                else if (resolvedPaymentTab === "expired") selectedType = expiredPlanType;
                else if (resolvedPaymentTab === "scheduled") selectedType = scheduledPlanType;

                url = `/get_payments.php?search=${encodeURIComponent(
                    search
                )}&filter=${encodeURIComponent(filter)}&plan_status=${encodeURIComponent(
                    resolvedPaymentTab
                )}&plan_type=${encodeURIComponent(selectedType)}&page=${resolvedPage}`;
            }

            if (!url) {
                return;
            }

            const res = await API.get(url);

            if (res.data.status === "success") {
                if (resolvedTab === "payments") {

                    setPayments(
                        res.data.data || []
                    );

                } else {

                    const loadedUsers =
                        res.data.data || [];

                    setUsers(
                        loadedUsers
                    );

                    /*
                     * Load broadband payment status only for
                     * Existing Users. Request users do not need
                     * payment information.
                     */
                    if (
                        resolvedTab ===
                        "existing"
                    ) {

                        await fetchBroadbandPaymentStatuses(
                            loadedUsers
                        );

                    } else {

                        setBroadbandPaymentStatuses(
                            {}
                        );

                    }

                }
                if (res.data.pagination) {
                    setPagination(res.data.pagination);
                }
            } else {
                toast.error(
                    res.data.message || "Unable to load data"
                );

                if (resolvedTab === "payments") {
                    setPayments([]);
                } else {
                    setUsers([]);
                }
            }
        } catch (error) {
            console.error("Fetch Admin Data Error:", error);

            toast.error(
                error.response?.data?.message ||
                "Unable to load admin data"
            );

            if (resolvedTab === "payments") {

                setPayments([]);

            } else {

                setUsers([]);

                if (
                    resolvedTab ===
                    "existing"
                ) {
                    setBroadbandPaymentStatuses({});
                }

            }
        } finally {
            if (showLoader) {
                setLoading(false);
            }
        }
    };

    /* =========================
       PLAN API FUNCTIONS
    ========================= */

    const fetchBroadbandPlans = async () => {
        try {
            setLoading(true);

            const res = await API.get(
                "/get_broadband_plans.php?admin=1"
            );

            if (res.data.status === "success") {
                setBroadbandPlans(res.data.data || []);
            } else {
                toast.error(
                    res.data.message || "Unable to load broadband plans"
                );
            }
        } catch (error) {
            console.error("Broadband Plans Error:", error);
            toast.error("Unable to load broadband plans");
        } finally {
            setLoading(false);
        }
    };

    const fetchOttPlatforms = async () => {
        try {
            setLoading(true);

            const res = await API.get(
                "/get_ott_platforms.php?admin=1"
            );

            if (res.data.status === "success") {
                setOttPlatforms(res.data.data || []);
            } else {
                toast.error(
                    res.data.message || "Unable to load OTT platforms"
                );
            }
        } catch (error) {
            console.error("OTT Platforms Error:", error);
            toast.error("Unable to load OTT platforms");
        } finally {
            setLoading(false);
        }
    };

    const fetchOttAddonPlans = async () => {
        try {
            setLoading(true);

            const res = await API.get(
                "/get_ott_addon_plans.php?admin=1"
            );

            if (res.data.status === "success") {
                setOttAddonPlans(res.data.data || []);
            } else {
                toast.error(
                    res.data.message || "Unable to load OTT add-on plans"
                );
            }
        } catch (error) {
            console.error("OTT Addon Plans Error:", error);
            toast.error("Unable to load OTT add-on plans");
        } finally {
            setLoading(false);
        }
    };

    const fetchPlanManagementData = async (showLoader = true) => {
        try {
            if (showLoader) {
                setLoading(true);
            }

            const [
                broadbandRes,
                ottRes,
                addonRes
            ] = await Promise.all([
                API.get("/get_broadband_plans.php?admin=1"),
                API.get("/get_ott_platforms.php?admin=1"),
                API.get("/get_ott_addon_plans.php?admin=1")
            ]);

            if (broadbandRes.data.status === "success") {
                setBroadbandPlans(
                    broadbandRes.data.data || []
                );
            } else {
                toast.error(
                    broadbandRes.data.message ||
                    "Unable to load broadband plans"
                );
            }

            if (ottRes.data.status === "success") {
                setOttPlatforms(
                    ottRes.data.data || []
                );
            } else {
                toast.error(
                    ottRes.data.message ||
                    "Unable to load OTT platforms"
                );
            }

            if (addonRes.data.status === "success") {
                setOttAddonPlans(
                    addonRes.data.data || []
                );
            } else {
                toast.error(
                    addonRes.data.message ||
                    "Unable to load OTT add-on plans"
                );
            }

        } catch (error) {

            console.error(
                "Plan Management Error:",
                error
            );

            toast.error(
                "Unable to load plan management data"
            );

        } finally {
            if (showLoader) {
                setLoading(false);
            }
        }
    };

    /* =========================
       EFFECTS
    ========================= */

    /*
     * INITIAL ADMIN LOAD
     *
     * Load dashboard cards, the default Request Users tab,
     * and plan-management data together when the page opens.
     * This prevents the page from depending on a later tab switch.
     */
    useEffect(() => {
        let mounted = true;

        const loadInitialAdminData = async () => {

            try {

                setLoading(true);

                /*
                 * Load dashboard statistics first and independently.
                 * A failure in another admin section must not prevent
                 * the dashboard cards from being populated.
                 */
                await fetchDashboardStats();

                if (!mounted) {
                    return;
                }

                /*
                 * Default Request Users data.
                 */
                await fetchData(false);

                if (!mounted) {
                    return;
                }

                /*
                 * Plan-management data is loaded independently.
                 */
                await fetchPlanManagementData(false);

            } catch (error) {

                console.error(
                    "Initial Admin Dashboard Error:",
                    error
                );

            } finally {

                if (mounted) {

                    setLoading(false);
                    setInitialLoadComplete(true);

                }

            }
        };

        loadInitialAdminData();

        return () => {
            mounted = false;
        };

    }, []);

    /*
     * Reload only the currently selected normal tab after the
     * initial page load. Plans are handled separately.
     */
    useEffect(() => {
        if (!initialLoadComplete) {
            return;
        }

        if (activeTab !== "plans") {
            fetchData();
        }
    }, [
        activeTab,
        search,
        filter,
        page,
        paymentTab,
        pendingPlanType,
        activePlanType,
        expiredPlanType,
        scheduledPlanType,
        pendingDateFilter,
        activeDateFilter,
        expiredDateFilter,
        scheduledDateFilter
    ]);

    /*
     * The initial Request Users data was already loaded by
     * the first effect. Avoid an unnecessary second request
     * on the first render, but load immediately when the user
     * switches tabs or changes search/filter/page.
     */
    // if (
    //     activeTab === "requests" &&
    //     search === "" &&
    //     filter === "" &&
    //     page === 1
    // ) {
    //     return;
    // }

    //     if (activeTab !== "plans") {
    //         fetchData();
    //     }
    // }, [activeTab, search, filter, page]);

    /* =========================
       REQUEST USER DELETE
    ========================= */

    const deleteRequestUser = async (id) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "This user will be permanently deleted from the database!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel"
        });

        if (result.isConfirmed) {
            try {
                const res = await API.post(
                    "/delete_request_user.php",
                    { id }
                );

                if (res.data.status === "success") {
                    await fetchData(false);
                    await fetchDashboardStats();

                    Swal.fire(
                        "Deleted!",
                        "User has been deleted.",
                        "success"
                    );
                }
            } catch (error) {
                console.error(error);
                toast.error("Unable to delete request");
            }
        }
    };

    /* =========================
       EXISTING USER DELETE
    ========================= */

    const deleteUser = async (username) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "This user will be permanently deleted from the database!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel"
        });

        if (result.isConfirmed) {
            try {
                const res = await API.post(
                    "/delete_user.php",
                    { username }
                );

                if (res.data.status === "success") {
                    await fetchData(false);
                    await fetchDashboardStats();

                    Swal.fire(
                        "Deleted!",
                        "User has been deleted.",
                        "success"
                    );
                }
            } catch (error) {
                console.error(error);
                toast.error("Unable to delete user");
            }
        }
    };

    /* =========================
       SEND REMINDER
    ========================= */

    const SendReminder = async (
        username,
        planName,
        planType,
        planStatus
    ) => {

        const payload = {
            username: username,
            plan_name: planName,
            plan_type: planType,
            plan_status: planStatus
        };

        console.log(
            "SEND REMINDER PAYLOAD:",
            payload
        );

        setLoading(true);

        try {

            const res = await API.post(
                "/send_reminder.php",
                payload
            );

            console.log(
                "SEND REMINDER RESPONSE:",
                res.data
            );

            if (res.data.status === "success") {

                toast.success(
                    "Reminder sent successfully."
                );

            } else {

                toast.error(
                    res.data.message ||
                    "Unable to send reminder"
                );
            }

        } catch (error) {

            console.error(
                "SEND REMINDER ERROR:",
                error
            );

            console.error(
                "SERVER RESPONSE:",
                error.response?.data
            );

            toast.error(
                error.response?.data?.message ||
                "Unable to send reminder"
            );

        } finally {

            setLoading(false);
        }
    };

    /* =========================
       APPROVE REQUEST USER
    ========================= */
    const approveRequest = async (user) => {

        const result = await Swal.fire({
            title: "Approve Request?",
            html: `
            <div style="text-align:left;">
                <p>Are you sure you want to approve this request?</p>

                <p>
                    <strong>Name:</strong>
                    ${user.name || "-"}
                </p>

                <p>
                    <strong>Email:</strong>
                    ${user.email || "-"}
                </p>

                <p>
                    <strong>Mobile:</strong>
                    ${user.mobile || "-"}
                </p>
            </div>
        `,
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#16a34a",
            cancelButtonColor: "#64748b",
            confirmButtonText: "Yes, Approve",
            cancelButtonText: "Cancel"
        });

        if (!result.isConfirmed) {
            return;
        }

        try {

            setLoading(true);

            const res = await API.post(
                "/approve_request_user.php",
                {
                    id: Number(user.id)
                }
            );

            if (res.data.status === "success") {

                // Stop the global loader FIRST
                setLoading(false);

                // Refresh table without showing global loader
                await fetchData(false);

                // Refresh dashboard stats
                await fetchDashboardStats();

                // Now show success popup
                await Swal.fire({
                    icon: "success",
                    title: "Request Approved",
                    text: "The request has been approved successfully. You can now send the registration link.",
                    confirmButtonColor: "#0056d2"
                });

            } else {

                setLoading(false);

                toast.error(
                    res.data.message ||
                    "Unable to approve request"
                );
            }

        } catch (error) {

            console.error(
                "Approve Request Error:",
                error
            );

            setLoading(false);

            toast.error(
                error.response?.data?.message ||
                "Unable to approve request"
            );
        }
    };

    /* =========================
       SEND REGISTRATION MAIL
    ========================= */

    const sendRegistrationMail = async (user) => {

        // Only approved users can receive registration link
        if (
            String(user.status || "").toLowerCase() !== "approved"
        ) {
            toast.error(
                "Please approve this request before sending the registration link."
            );
            return;
        }

        const registrationState =
            getRegistrationState(user);

        if (registrationState === "completed") {
            toast.info(
                "Registration has already been completed for this user."
            );
            return;
        }

        const result = await Swal.fire({
            title: "Send Registration Link?",
            html: `
            <div style="text-align:left;">
                <p>
                    A registration link will be sent to:
                </p>

                <p>
                    <strong>Name:</strong>
                    ${user.name || "-"}
                </p>

                <p>
                    <strong>Email:</strong>
                    ${user.email || "-"}
                </p>

                <p style="margin-top:15px;color:#64748b;">
                    The registration link will be valid for
                    <strong>30 minutes</strong>.
                </p>
            </div>
        `,
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#0056d2",
            cancelButtonColor: "#64748b",
            confirmButtonText: "Yes, Send Link",
            cancelButtonText: "Cancel"
        });

        if (!result.isConfirmed) {
            return;
        }

        try {

            setLoading(true);

            const res = await API.post(
                "/send_registration_mail.php",
                {
                    id: Number(user.id)
                }
            );

            if (res.data.status === "success") {

                // IMPORTANT:
                // Stop global loader before opening Swal
                setLoading(false);

                // Refresh table silently
                await fetchData(false);

                // Show success message
                await Swal.fire({
                    icon: "success",
                    title: "Registration Link Sent",
                    html: `
                    <p>
                        Registration link has been sent to
                        <strong>${user.email}</strong>.
                    </p>

                    <p style="color:#64748b;">
                        The link is valid for
                        <strong>30 minutes</strong>.
                    </p>
                `,
                    confirmButtonColor: "#0056d2"
                });

            } else {

                setLoading(false);

                toast.error(
                    res.data.message ||
                    "Unable to send registration link"
                );
            }

        } catch (error) {

            console.error(
                "Send Registration Mail Error:",
                error
            );

            setLoading(false);

            toast.error(
                error.response?.data?.message ||
                "Unable to send registration link"
            );
        }
    };
 

    /* =========================================================
       ACTIVATE PAYMENT PLAN
    ========================================================= */

    const activatePlan = async (payment) => {

        if (!payment?.id) {
            toast.error("Payment record ID is missing");
            return;
        }

        const result = await Swal.fire({
            title: "",
            html: `
            <div style="font-family:'Outfit',sans-serif; text-align:left;">

                <!-- Header Banner -->
                <div style="
                    background: linear-gradient(135deg, #15803d 0%, #22c55e 100%);
                    margin: -20px -20px 20px -20px;
                    padding: 24px 24px 20px;
                    border-radius: 12px 12px 0 0;
                    position: relative;
                    overflow: hidden;
                ">
                    <div style="
                        position:absolute; top:-20px; right:-20px;
                        width:100px; height:100px;
                        background:rgba(255,255,255,0.07);
                        border-radius:50%;
                    "></div>
                    <div style="
                        position:absolute; bottom:-30px; right:40px;
                        width:70px; height:70px;
                        background:rgba(255,255,255,0.05);
                        border-radius:50%;
                    "></div>
                    <div style="display:flex; align-items:center; gap:12px; position:relative; z-index:1;">
                        <div style="
                            width:42px; height:42px;
                            background:rgba(255,255,255,0.18);
                            border-radius:10px;
                            display:flex; align-items:center; justify-content:center;
                            font-size:20px;
                        ">⚡</div>
                        <div>
                            <p style="margin:0; font-size:18px; font-weight:700; color:#fff;">Activate Plan</p>
                            <p style="margin:0; font-size:12px; color:rgba(255,255,255,0.8);">Review details before confirming</p>
                        </div>
                    </div>
                </div>

                <!-- Info Cards -->
                <div style="display:grid; grid-template-columns:1fr 1fr; gap:10px; margin-bottom:12px;">
                    <div style="
                        background:#f0f7ff;
                        border:1px solid #dbeafe;
                        border-radius:10px;
                        padding:12px 14px;
                    ">
                        <p style="margin:0 0 3px; font-size:11px; font-weight:600; color:#3b82f6; text-transform:uppercase; letter-spacing:0.5px;">👤 Customer</p>
                        <p style="margin:0; font-size:13px; font-weight:600; color:#1e3a8a;">${payment.customer_name || "—"}</p>
                    </div>
                    <div style="
                        background:#f0fdf4;
                        border:1px solid #bbf7d0;
                        border-radius:10px;
                        padding:12px 14px;
                    ">
                        <p style="margin:0 0 3px; font-size:11px; font-weight:600; color:#16a34a; text-transform:uppercase; letter-spacing:0.5px;">📡 Plan</p>
                        <p style="margin:0; font-size:13px; font-weight:600; color:#15803d;">${payment.plan_name || "—"}</p>
                    </div>
                </div>

                <!-- Amount Card -->
                <div style="
                    background: linear-gradient(135deg, #fefce8, #fef9c3);
                    border: 1px solid #fde68a;
                    border-radius:10px;
                    padding:12px 14px;
                    margin-bottom:14px;
                    display:flex; align-items:center; gap:10px;
                ">
                    <span style="font-size:20px;">💰</span>
                    <div>
                        <p style="margin:0 0 2px; font-size:11px; font-weight:600; color:#92400e; text-transform:uppercase; letter-spacing:0.5px;">Amount</p>
                        <p style="margin:0; font-size:16px; font-weight:700; color:#78350f;">₹${payment.amount || "0"}</p>
                    </div>
                </div>

                <!-- Info Note -->
                <div style="
                    background:#eff6ff;
                    border-left: 4px solid #3b82f6;
                    border-radius: 0 8px 8px 0;
                    padding: 10px 14px;
                    display:flex; gap:8px; align-items:flex-start;
                ">
                    <span style="font-size:15px; margin-top:1px;">ℹ️</span>
                    <p style="margin:0; font-size:12px; color:#1e40af; line-height:1.5;">
                        The plan start date will be set using <strong>Asia/Kolkata</strong> time and the expiry date will be calculated from the selected plan duration.
                    </p>
                </div>

            </div>
            `,
            showCancelButton: true,
            confirmButtonColor: "#15803d",
            cancelButtonColor: "#94a3b8",
            confirmButtonText: "⚡ Activate Plan",
            cancelButtonText: "Cancel",
            didOpen: () => {
                const popup = document.querySelector(".swal2-popup");
                if (popup) {
                    popup.style.borderRadius = "16px";
                    popup.style.padding = "20px";
                    popup.style.boxShadow = "0 25px 50px rgba(15,23,42,0.18)";
                    popup.style.maxWidth = "440px";
                }
                const actions = document.querySelector(".swal2-actions");
                if (actions) {
                    actions.style.gap = "10px";
                    actions.style.marginTop = "20px";
                }
                const confirm = document.querySelector(".swal2-confirm");
                if (confirm) {
                    confirm.style.borderRadius = "9px";
                    confirm.style.padding = "10px 24px";
                    confirm.style.fontWeight = "600";
                    confirm.style.fontSize = "14px";
                }
                const cancel = document.querySelector(".swal2-cancel");
                if (cancel) {
                    cancel.style.borderRadius = "9px";
                    cancel.style.padding = "10px 20px";
                    cancel.style.fontWeight = "500";
                    cancel.style.fontSize = "14px";
                }
            }
        });

        if (!result.isConfirmed) {
            return;
        }

        try {

            setActivatingPlanId(payment.id);

            /*
            =====================================================
            1. ACTIVATE PLAN
            =====================================================
            */

            const res = await API.post(
                "/activate_plan.php",
                {
                    payment_id: Number(payment.id)
                }
            );

            console.log(
                "Activate Plan Response:",
                res.data
            );

            /*
            =====================================================
            2. VALIDATE ACTIVATION RESPONSE
            =====================================================
            */

            const activationSuccess =
                res.data?.success === true ||
                String(
                    res.data?.status || ""
                )
                    .trim()
                    .toLowerCase() === "success";

            if (!activationSuccess) {

                toast.error(
                    res.data?.message ||
                    "Unable to activate plan"
                );

                return;
            }

            /*
            =====================================================
            ACTIVATION IS SUCCESSFUL
            =====================================================
    
            From this point onward, the plan is already ACTIVE
            in the database.
    
            Any failure below is only a UI refresh problem.
            It must NOT show "Unable to activate plan".
            =====================================================
            */

            console.log(
                "Plan activated successfully:",
                res.data
            );


            /*
            =====================================================
            3. UPDATE UI STATE IMMEDIATELY
            =====================================================
            */

            setPaymentTab("active");
            setPage(1);

            /*
            =====================================================
            4. REFRESH ACTIVE PLANS
            =====================================================
            */

            try {

                const activeUrl =
                    `/get_payments.php` +
                    `?search=${encodeURIComponent(search || "")}` +
                    `&filter=` +
                    `&plan_status=active` +
                    `&plan_type=${encodeURIComponent(activePlanType)}` +
                    `&page=1` +
                    `&_ts=${Date.now()}`;

                console.log(
                    "Loading Active Plans:",
                    activeUrl
                );

                const activeResponse = await API.get(
                    activeUrl,
                    {
                        headers: {
                            Accept: "application/json",
                            "Cache-Control": "no-cache"
                        }
                    }
                );

                console.log(
                    "Active Plans Response:",
                    activeResponse.data
                );

                const activeSuccess =
                    activeResponse.data?.success === true ||
                    String(
                        activeResponse.data?.status || ""
                    )
                        .trim()
                        .toLowerCase() === "success";

                if (activeSuccess) {

                    const activePayments =
                        Array.isArray(
                            activeResponse.data?.data
                        )
                            ? activeResponse.data.data
                            : [];

                    setPayments(
                        activePayments
                    );

                    if (
                        activeResponse.data?.pagination
                    ) {

                        setPagination(
                            activeResponse.data.pagination
                        );

                    }

                } else {

                    console.warn(
                        "Plan activated successfully, but Active Plans response was invalid:",
                        activeResponse.data
                    );

                }

            } catch (refreshError) {

                /*
                IMPORTANT:
    
                Do NOT show:
    
                    Unable to activate plan
    
                because activation already succeeded.
    
                This error is only related to refreshing the
                Active Plans table.
                */

                console.warn(
                    "Active Plans refresh failed after successful activation:",
                    refreshError
                );

            }


            /*
            =====================================================
            5. REFRESH DASHBOARD COUNTS
            =====================================================
            */

            try {

                await fetchDashboardStats();

                /*
                 * Refresh the Existing Users broadband payment
                 * status cache after activation.
                 */
                if (
                    Array.isArray(users) &&
                    users.length > 0
                ) {

                    await fetchBroadbandPaymentStatuses(
                        users
                    );

                }

            } catch (statsError) {

                /*
                Dashboard refresh failure must not change the
                activation result.
                */

                console.warn(
                    "Dashboard stats refresh failed after activation:",
                    statsError
                );

            }


            /*
            =====================================================
            6. SHOW SUCCESS MESSAGE
            =====================================================
            */

            await Swal.fire({

                icon: "success",

                title: "Plan Activated",

                text:
                    res.data?.message ||
                    "Plan has been activated successfully.",

                confirmButtonColor: "#0056d2"

            });


        } catch (error) {

            /*
            =====================================================
            ONLY THIS BLOCK MEANS ACTIVATION ITSELF FAILED
            =====================================================
            */

            console.error(
                "Activate Plan Error:",
                error
            );

            console.error(
                "Activate Plan Response:",
                error?.response?.data
            );

            toast.error(
                error?.response?.data?.message ||
                "Unable to activate plan"
            );

        } finally {

            setActivatingPlanId(null);

        }
    };
    const editPlanDates = async (payment) => {

        if (!payment?.id) {

            toast.error("Payment record ID is missing");

            return;
        }


        /*
        =====================================================
        CONVERT DATABASE DATE TO YYYY-MM-DD
        =====================================================
        */

        const getInputDate = (dateValue) => {

            if (!dateValue) {
                return "";
            }

            return String(dateValue)
                .substring(0, 10);

        };


        const currentStartDate =
            getInputDate(
                payment.plan_start_date
            );


        const currentExpiryDate =
            getInputDate(
                payment.plan_expiry_date
            );


        /*
        =====================================================
        EDIT POPUP
        =====================================================
        */

        const result = await Swal.fire({

            title: "",

            html: `
            <div style="font-family:'Outfit',sans-serif; text-align:left;">

                <!-- Header Banner -->
                <div style="
                    background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
                    margin: -20px -20px 20px -20px;
                    padding: 24px 24px 20px;
                    border-radius: 12px 12px 0 0;
                    position: relative;
                    overflow: hidden;
                ">
                    <div style="
                        position:absolute; top:-20px; right:-20px;
                        width:100px; height:100px;
                        background:rgba(255,255,255,0.07);
                        border-radius:50%;
                    "></div>
                    <div style="
                        position:absolute; bottom:-30px; right:40px;
                        width:70px; height:70px;
                        background:rgba(255,255,255,0.05);
                        border-radius:50%;
                    "></div>
                    <div style="display:flex; align-items:center; gap:12px; position:relative; z-index:1;">
                        <div style="
                            width:42px; height:42px;
                            background:rgba(255,255,255,0.18);
                            border-radius:10px;
                            display:flex; align-items:center; justify-content:center;
                            font-size:18px;
                        ">📅</div>
                        <div>
                            <p style="margin:0; font-size:18px; font-weight:700; color:#fff;">Edit Plan Dates</p>
                            <p style="margin:0; font-size:12px; color:rgba(255,255,255,0.75);">Update start & expiry dates below</p>
                        </div>
                    </div>
                </div>

                <!-- Info Cards Row -->
                <div style="display:grid; grid-template-columns:1fr 1fr; gap:10px; margin-bottom:20px;">
                    <div style="
                        background:#f0f7ff;
                        border:1px solid #dbeafe;
                        border-radius:10px;
                        padding:12px 14px;
                    ">
                        <p style="margin:0 0 3px; font-size:11px; font-weight:600; color:#3b82f6; text-transform:uppercase; letter-spacing:0.5px;">👤 Customer</p>
                        <p style="margin:0; font-size:13px; font-weight:600; color:#1e3a8a;">${payment.customer_name || "—"}</p>
                    </div>
                    <div style="
                        background:#f0fdf4;
                        border:1px solid #bbf7d0;
                        border-radius:10px;
                        padding:12px 14px;
                    ">
                        <p style="margin:0 0 3px; font-size:11px; font-weight:600; color:#16a34a; text-transform:uppercase; letter-spacing:0.5px;">📡 Plan</p>
                        <p style="margin:0; font-size:13px; font-weight:600; color:#15803d;">${payment.plan_name || "—"}</p>
                    </div>
                </div>

                <!-- Date Fields -->
                <div style="margin-bottom:14px;">
                    <label style="
                        display:flex; align-items:center; gap:6px;
                        margin-bottom:7px; font-size:13px;
                        font-weight:600; color:#334155;
                    ">
                        <span style="color:#3b82f6;">▶</span> Plan Start Date
                    </label>
                    <input
                        id="swal-plan-start-date"
                        type="date"
                        value="${currentStartDate}"
                        style="
                            width:100%; box-sizing:border-box;
                            padding:10px 14px;
                            border:1.5px solid #cbd5e1;
                            border-radius:9px;
                            font-size:14px; color:#1e3a8a;
                            background:#f8fafc;
                            outline:none;
                            font-family:'Outfit',sans-serif;
                            transition: border-color 0.2s;
                        "
                        onfocus="this.style.borderColor='#3b82f6'; this.style.background='#fff';"
                        onblur="this.style.borderColor='#cbd5e1'; this.style.background='#f8fafc';"
                    />
                </div>

                <div>
                    <label style="
                        display:flex; align-items:center; gap:6px;
                        margin-bottom:7px; font-size:13px;
                        font-weight:600; color:#334155;
                    ">
                        <span style="color:#ef4444;">■</span> Plan Expiry Date
                    </label>
                    <input
                        id="swal-plan-expiry-date"
                        type="date"
                        value="${currentExpiryDate}"
                        style="
                            width:100%; box-sizing:border-box;
                            padding:10px 14px;
                            border:1.5px solid #cbd5e1;
                            border-radius:9px;
                            font-size:14px; color:#1e3a8a;
                            background:#f8fafc;
                            outline:none;
                            font-family:'Outfit',sans-serif;
                            transition: border-color 0.2s;
                        "
                        onfocus="this.style.borderColor='#3b82f6'; this.style.background='#fff';"
                        onblur="this.style.borderColor='#cbd5e1'; this.style.background='#f8fafc';"
                    />
                </div>

            </div>
            `,

            showCancelButton: true,

            confirmButtonText: "✔ Update Dates",

            cancelButtonText: "Cancel",

            confirmButtonColor: "#1e3a8a",

            cancelButtonColor: "#94a3b8",

            customClass: {
                popup: "swal-premium-popup",
                confirmButton: "swal-premium-confirm",
                cancelButton: "swal-premium-cancel",
            },

            didOpen: () => {
                const popup = document.querySelector(".swal2-popup");
                if (popup) {
                    popup.style.borderRadius = "16px";
                    popup.style.padding = "20px";
                    popup.style.boxShadow = "0 25px 50px rgba(15,23,42,0.18)";
                    popup.style.maxWidth = "440px";
                }
                const actions = document.querySelector(".swal2-actions");
                if (actions) {
                    actions.style.gap = "10px";
                    actions.style.marginTop = "20px";
                }
                const confirm = document.querySelector(".swal2-confirm");
                if (confirm) {
                    confirm.style.borderRadius = "9px";
                    confirm.style.padding = "10px 24px";
                    confirm.style.fontWeight = "600";
                    confirm.style.fontSize = "14px";
                    confirm.style.letterSpacing = "0.3px";
                }
                const cancel = document.querySelector(".swal2-cancel");
                if (cancel) {
                    cancel.style.borderRadius = "9px";
                    cancel.style.padding = "10px 20px";
                    cancel.style.fontWeight = "500";
                    cancel.style.fontSize = "14px";
                }
            },


            preConfirm: () => {

                const startDate =
                    document.getElementById(
                        "swal-plan-start-date"
                    ).value;


                const expiryDate =
                    document.getElementById(
                        "swal-plan-expiry-date"
                    ).value;


                if (!startDate) {

                    Swal.showValidationMessage(
                        "Please select the start date"
                    );

                    return false;
                }


                if (!expiryDate) {

                    Swal.showValidationMessage(
                        "Please select the expiry date"
                    );

                    return false;
                }


                if (
                    expiryDate < startDate
                ) {

                    Swal.showValidationMessage(
                        "Expiry date cannot be before start date"
                    );

                    return false;
                }


                return {
                    startDate,
                    expiryDate
                };

            }

        });


        /*
        =====================================================
        CANCELLED
        =====================================================
        */

        if (!result.isConfirmed) {

            return;
        }


        try {

            setLoading(true);


            /*
            =================================================
            UPDATE API
            =================================================
            */

            const response = await API.post(
                "/update_plan_dates.php",
                {
                    payment_id:
                        Number(payment.id),

                    plan_start_date:
                        result.value.startDate,

                    plan_expiry_date:
                        result.value.expiryDate
                }
            );


            /*
            =================================================
            SUCCESS
            =================================================
            */

            if (
                response.data?.status ===
                "success"
            ) {

                toast.success(
                    "Plan dates updated successfully"
                );


                /*
                =============================================
                REFRESH CURRENT PAYMENT TAB
                =============================================
                */

                await fetchData(
                    false,
                    "payments",
                    paymentTab,
                    page
                );


                return;
            }


            /*
            =================================================
            ERROR RESPONSE
            =================================================
            */

            toast.error(
                response.data?.message ||
                "Unable to update plan dates"
            );


        } catch (error) {

            console.error(
                "Update plan dates error:",
                error
            );


            toast.error(
                error?.response?.data?.message ||
                "Unable to update plan dates"
            );


        } finally {

            setLoading(false);

        }

    };
    /* =========================
       ROLE
    ========================= */

    const saveRole = async (username) => {
        const role = roleChanges[username];

        if (!role) return;

        try {
            setLoading(true);

            const res = await API.post(
                "/update_role.php",
                { username, role }
            );

            if (res.data.status === "success") {
                toast.success("Role updated successfully.");
                await fetchData(false);
                await fetchDashboardStats();
            }
        } catch (error) {
            console.error(error);
            toast.error("Unable to update role");
        } finally {
            setLoading(false);
        }
    };

    /* =========================================================
       BROADBAND PLAN FORM
    ========================================================= */

    const openAddPlan = () => {
        setEditingPlan(null);
        setPlanForm(emptyPlan);
        clearPlanErrors();
        setShowPlanModal(true);
    };

    const openEditPlan = (plan) => {
        setEditingPlan(plan);

        setPlanForm({
            id: plan.id,
            plan_name: plan.plan_name || "",
            speed: plan.speed || "",
            tagline: plan.tagline || "",
            is_popular: Boolean(plan.is_popular),
            display_order: plan.display_order || 0,
            active: Boolean(plan.active),

            durations:
                plan.durations?.length > 0
                    ? plan.durations.map((duration) => ({
                        id: duration.id,
                        months: duration.months,
                        duration_label:
                            duration.duration_label ||
                            duration.label ||
                            `${duration.months} Months`,
                        price: duration.price,
                        badge: duration.badge || "",
                        active: Boolean(duration.active),
                        display_order:
                            duration.display_order || 0
                    }))
                    : emptyPlan.durations,

            features:
                plan.features?.length > 0
                    ? plan.features.map(
                        (feature) =>
                            feature.feature_text || ""
                    )
                    : [""]
        });

        clearPlanErrors();
        setShowPlanModal(true);
    };

    const updatePlanField = (field, value) => {
        setPlanForm((prev) => ({
            ...prev,
            [field]: value
        }));
        // Clear error for this field when user types
        if (planErrors[field]) {
            setPlanErrors((prev) => ({ ...prev, [field]: false }));
        }
    };

    const addDuration = () => {
        setPlanForm((prev) => ({
            ...prev,
            durations: [
                ...prev.durations,
                {
                    months: 1,
                    duration_label: "1 Month",
                    price: "",
                    badge: "",
                    active: true,
                    display_order:
                        prev.durations.length + 1
                }
            ]
        }));
    };

    const removeDuration = (index) => {
        setPlanForm((prev) => ({
            ...prev,
            durations: prev.durations.filter(
                (_, i) => i !== index
            )
        }));
    };

    const updateDuration = (index, field, value) => {
        setPlanForm((prev) => ({
            ...prev,
            durations: prev.durations.map(
                (duration, i) =>
                    i === index
                        ? {
                            ...duration,
                            [field]: value
                        }
                        : duration
            )
        }));
        // Clear per-duration error for this field
        setDurationErrors((prev) => {
            const next = [...prev];
            if (next[index]) {
                next[index] = { ...next[index], [field]: false };
            }
            return next;
        });
    };

    const addFeature = () => {
        setPlanForm((prev) => ({
            ...prev,
            features: [...prev.features, ""]
        }));
    };

    const removeFeature = (index) => {
        setPlanForm((prev) => ({
            ...prev,
            features: prev.features.filter(
                (_, i) => i !== index
            )
        }));
    };

    const updateFeature = (index, value) => {
        setPlanForm((prev) => ({
            ...prev,
            features: prev.features.map(
                (feature, i) =>
                    i === index ? value : feature
            )
        }));
    };

    const saveBroadbandPlan = async () => {
        // --- Per-field validation ---
        const errors = {};
        let hasError = false;

        if (!planForm.plan_name.trim()) {
            errors.plan_name = "Plan name is required";
            hasError = true;
        }

        if (!planForm.speed || Number(planForm.speed) <= 0) {
            errors.speed = "Valid speed (Mbps) is required";
            hasError = true;
        }

        // Per-duration validation
        const durErrs = planForm.durations.map((dur) => {
            const de = {};
            if (!dur.months || Number(dur.months) <= 0) de.months = true;
            if (dur.price === "" || Number(dur.price) < 0) de.price = true;
            return de;
        });
        const anyDurError = durErrs.some(
            (de) => Object.keys(de).length > 0
        );
        if (anyDurError) hasError = true;

        if (hasError) {
            setPlanErrors(errors);
            setDurationErrors(durErrs);
            if (!planForm.plan_name.trim() || !planForm.speed) {
                toast.error("Please fill all required fields highlighted in red");
            } else {
                toast.error("Each duration needs valid months and price");
            }
            return;
        }

        setPlanErrors({});
        setDurationErrors([]);

        try {
            setLoading(true);

            const payload = {
                ...planForm,
                speed: Number(planForm.speed),
                display_order: Number(
                    planForm.display_order || 0
                ),
                is_popular: Boolean(planForm.is_popular),
                active: Boolean(planForm.active),
                durations: planForm.durations.map(
                    (duration, index) => ({
                        ...duration,
                        months: Number(duration.months),
                        price: Number(duration.price),
                        display_order:
                            Number(
                                duration.display_order
                            ) || index + 1,
                        active: Boolean(duration.active)
                    })
                ),
                features: planForm.features
                    .map((feature) => feature.trim())
                    .filter(Boolean)
            };

            const endpoint = editingPlan
                ? "/update_broadband_plan.php"
                : "/create_broadband_plan.php";

            const res = await API.post(
                endpoint,
                payload
            );

            if (res.data.status === "success") {
                toast.success(
                    editingPlan
                        ? "Broad Band plan updated successfully"
                        : "Broad Band plan created successfully"
                );

                setShowPlanModal(false);
                setEditingPlan(null);
                setPlanForm(emptyPlan);

                await fetchBroadbandPlans();
            } else {
                toast.error(
                    res.data.message ||
                    "Unable to save Broad Band plan"
                );
            }
        } catch (error) {
            console.error(
                "Save Broad Band Plan Error:",
                error
            );

            toast.error(
                error.response?.data?.message ||
                "Unable to save broad band plan"
            );
        } finally {
            setLoading(false);
        }
    };

    /* =========================================================
       BROADBAND DELETE / TOGGLE
    ========================================================= */

    const deleteBroadbandPlan = async (id) => {
        const result = await Swal.fire({
            title: "Delete broad band plan?",
            text: "If this plan is already used in payments, it will be disabled instead.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, continue"
        });

        if (!result.isConfirmed) return;

        try {
            setLoading(true);

            const res = await API.post(
                "/delete_broadband_plan.php",
                { id }
            );

            if (res.data.status === "success") {
                toast.success(
                    res.data.message ||
                    "Broad Band plan deleted successfully"
                );

                await fetchBroadbandPlans();
            } else {
                toast.error(
                    res.data.message ||
                    "Unable to delete plan"
                );
            }
        } catch (error) {
            console.error(error);
            toast.error("Unable to delete broad band plan");
        } finally {
            setLoading(false);
        }
    };

    const toggleBroadbandPlan = async (plan) => {
        const newStatus = plan.active ? 0 : 1;

        const result = await Swal.fire({
            title: newStatus
                ? "Enable this plan?"
                : "Disable this plan?",
            text: newStatus
                ? "This plan will be visible to users."
                : "This plan will no longer be shown to users.",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Yes, continue"
        });

        if (!result.isConfirmed) return;

        try {
            setLoading(true);

            const res = await API.post(
                "/toggle_broadband_plan.php",
                {
                    id: plan.id,
                    active: newStatus
                }
            );

            if (res.data.status === "success") {
                toast.success(res.data.message);
                await fetchBroadbandPlans();
            }
        } catch (error) {
            console.error(error);
            toast.error("Unable to update plan status");
        } finally {
            setLoading(false);
        }
    };

    /* =========================================================
       OTT PLATFORM
    ========================================================= */

    // const openAddOtt = () => {
    //     setEditingOtt(null);
    //     setOttForm(emptyOtt);
    //     setShowOttModal(true);
    // };
    const openAddOtt = () => {
        setEditingOtt(null);

        setOttForm({
            ott_name: "",
            logo: "",
            logo_file: null,
            display_order: 0,
            active: true
        });

        setOttLogoPreview("");
        clearOttErrors();
        setShowOttModal(true);
    };
    // const openEditOtt = (ott) => {
    //     setEditingOtt(ott);

    //     setOttForm({
    //         id: ott.id,
    //         ott_name: ott.ott_name || ott.name || "",
    //         logo: ott.logo || "",
    //         display_order: ott.display_order || 0,
    //         active: Boolean(ott.active)
    //     });

    //     setShowOttModal(true);
    // };
    const openEditOtt = (ott) => {
        setEditingOtt(ott);

        setOttForm({
            id: ott.id,
            ott_name: ott.ott_name || ott.name || "",
            logo: ott.logo || "",
            logo_file: null,
            display_order: ott.display_order || 0,
            active: Boolean(ott.active)
        });

        setOttLogoPreview(ott.logo || "");
        clearOttErrors();
        setShowOttModal(true);
    };
    const handleOttLogoChange = (e) => {
        const file = e.target.files?.[0];

        if (!file) {
            return;
        }

        const allowedTypes = [
            "image/jpeg",
            "image/png"
        ];

        if (!allowedTypes.includes(file.type)) {
            toast.error(
                "Only JPG, JPEG and PNG images are allowed"
            );

            e.target.value = "";
            return;
        }

        // Optional: 2 MB maximum
        const maxSize = 2 * 1024 * 1024;

        if (file.size > maxSize) {
            toast.error(
                "Logo image must be less than 2 MB"
            );

            e.target.value = "";
            return;
        }

        setOttForm((prev) => ({
            ...prev,
            logo_file: file
        }));

        const previewUrl = URL.createObjectURL(file);

        setOttLogoPreview(previewUrl);
    };
    // const saveOttPlatform = async () => {
    //     if (!ottForm.ott_name.trim()) {
    //         toast.error("OTT name is required");
    //         return;
    //     }

    //     try {
    //         setLoading(true);

    //         const endpoint = editingOtt
    //             ? "/update_ott_platform.php"
    //             : "/create_ott_platform.php";

    //         const res = await API.post(
    //             endpoint,
    //             {
    //                 ...ottForm,
    //                 display_order: Number(
    //                     ottForm.display_order || 0
    //                 ),
    //                 active: Boolean(ottForm.active)
    //             }
    //         );

    //         if (res.data.status === "success") {
    //             toast.success(
    //                 editingOtt
    //                     ? "OTT platform updated successfully"
    //                     : "OTT platform created successfully"
    //             );

    //             setShowOttModal(false);
    //             setEditingOtt(null);
    //             setOttForm(emptyOtt);

    //             await fetchOttPlatforms();
    //         } else {
    //             toast.error(
    //                 res.data.message ||
    //                 "Unable to save OTT platform"
    //             );
    //         }
    //     } catch (error) {
    //         console.error(error);
    //         toast.error(
    //             error.response?.data?.message ||
    //             "Unable to save OTT platform"
    //         );
    //     } finally {
    //         setLoading(false);
    //     }
    // };
    const saveOttPlatform = async () => {
        // --- Per-field validation ---
        if (!ottForm.ott_name.trim()) {
            setOttErrors({ ott_name: "OTT platform name is required" });
            toast.error("OTT platform name is required");
            return;
        }
        setOttErrors({});

        try {
            setOttSaving(true);

            const endpoint = editingOtt
                ? "/update_ott_platform.php"
                : "/create_ott_platform.php";

            const formData = new FormData();

            if (editingOtt) {
                formData.append("id", String(editingOtt.id));
            }

            formData.append(
                "ott_name",
                ottForm.ott_name.trim()
            );

            formData.append(
                "logo",
                ottForm.logo || ""
            );

            formData.append(
                "display_order",
                String(Number(ottForm.display_order || 0))
            );

            formData.append(
                "active",
                ottForm.active ? "1" : "0"
            );

            if (ottForm.logo_file) {
                formData.append(
                    "logo_file",
                    ottForm.logo_file
                );
            }

            const res = await API.post(
                endpoint,
                formData
            );

            if (res.data.status !== "success") {
                throw new Error(
                    res.data.message ||
                    "Unable to save OTT platform"
                );
            }

            toast.success(
                editingOtt
                    ? "OTT platform updated successfully"
                    : "OTT platform created successfully"
            );

            setShowOttModal(false);
            setEditingOtt(null);

            setOttForm({
                ott_name: "",
                logo: "",
                logo_file: null,
                display_order: 0,
                active: true
            });

            setOttLogoPreview("");

            await fetchOttPlatforms();

        } catch (error) {
            console.error("Save OTT Platform Error:", error);

            toast.error(
                error.response?.data?.message ||
                error.message ||
                "Unable to save OTT platform"
            );
        } finally {
            setOttSaving(false);
        }
    };

    const deleteOttPlatform = async (id) => {
        const result = await Swal.fire({
            title: "Delete OTT platform?",
            text: "If this OTT is assigned to plans, it will be disabled instead.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, continue"
        });

        if (!result.isConfirmed) return;

        try {
            setLoading(true);

            const res = await API.post(
                "/delete_ott_platform.php",
                { id }
            );

            if (res.data.status === "success") {
                toast.success(res.data.message);
                await fetchOttPlatforms();
            }
        } catch (error) {
            console.error(error);
            toast.error("Unable to delete OTT platform");
        } finally {
            setLoading(false);
        }
    };

    const toggleOttPlatform = async (ott) => {
        try {
            setLoading(true);

            const res = await API.post(
                "/toggle_ott_platform.php",
                {
                    id: ott.id,
                    active: ott.active ? 0 : 1
                }
            );

            if (res.data.status === "success") {
                toast.success(res.data.message);
                await fetchOttPlatforms();
            }
        } catch (error) {
            console.error(error);
            toast.error(
                "Unable to update OTT platform status"
            );
        } finally {
            setLoading(false);
        }
    };

    /* =========================================================
       OTT ASSIGNMENT
    ========================================================= */

    const openOttAssignment = async (
        plan,
        duration
    ) => {
        setSelectedPlanForOtt(plan);
        setSelectedDuration(duration);
        setSelectedOttIds([]);
        setShowOttAssignmentModal(true);

        try {
            setOttLoading(true);

            const res = await API.get(
                `/get_plan_ott_assignments.php?plan_duration_id=${duration.id}`
            );

            if (res.data.status === "success") {
                const assigned = (res.data.data || [])
                    .filter(
                        (ott) => Number(ott.assigned) === 1
                    )
                    .map((ott) => Number(ott.id));

                setSelectedOttIds(assigned);
            }
        } catch (error) {
            console.error(error);
            toast.error(
                "Unable to load OTT assignments"
            );
        } finally {
            setOttLoading(false);
        }
    };

    const toggleSelectedOtt = (id) => {
        setSelectedOttIds((prev) =>
            prev.includes(Number(id))
                ? prev.filter(
                    (ottId) =>
                        ottId !== Number(id)
                )
                : [...prev, Number(id)]
        );
    };

    const saveOttAssignments = async () => {
        if (!selectedDuration?.id) {
            toast.error("Duration not selected");
            return;
        }

        try {
            setOttLoading(true);

            const res = await API.post(
                "/save_plan_ott_assignments.php",
                {
                    plan_duration_id:
                        selectedDuration.id,
                    ott_platform_ids:
                        selectedOttIds
                }
            );

            if (res.data.status === "success") {
                toast.success(
                    "OTT configuration saved successfully"
                );

                setShowOttAssignmentModal(false);

                await fetchBroadbandPlans();
            } else {
                toast.error(
                    res.data.message ||
                    "Unable to save OTT configuration"
                );
            }
        } catch (error) {
            console.error(error);
            toast.error(
                "Unable to save OTT configuration"
            );
        } finally {
            setOttLoading(false);
        }
    };

    /* =========================================================
       OTT ADD-ON OTT ASSIGNMENT
    ========================================================= */

    const openAddonOttAssignment = async (addon) => {
        /*
         * Always clear the previous plan's selection first.
         * This prevents stale OTT selections from appearing while
         * the newly selected add-on plan is loading.
         */
        setSelectedAddonForOtt(addon);
        setSelectedAddonOttIds([]);
        setShowAddonOttAssignmentModal(true);

        try {
            setAddonOttLoading(true);

            /*
             * The admin get_ott_addon_plans.php API now returns:
             *
             * ott_platform_ids: [1, 4, 7]
             *
             * Use these saved IDs directly when available.
             */
            if (Array.isArray(addon?.ott_platform_ids)) {
                const savedIds = [
                    ...new Set(
                        addon.ott_platform_ids
                            .map((id) => Number(id))
                            .filter(
                                (id) =>
                                    Number.isInteger(id) &&
                                    id > 0
                            )
                    )
                ];

                setSelectedAddonOttIds(savedIds);
                return;
            }

            /*
             * Backward-compatible fallback for an older API response.
             */
            const res = await API.get(
                `/get_addon_ott_assignments.php?ott_addon_plan_id=${addon.id}`
            );

            if (res.data.status === "success") {
                const assigned = [
                    ...new Set(
                        (res.data.data || [])
                            .filter(
                                (ott) =>
                                    Number(ott.assigned) === 1
                            )
                            .map(
                                (ott) =>
                                    Number(ott.id)
                            )
                            .filter(
                                (id) =>
                                    Number.isInteger(id) &&
                                    id > 0
                            )
                    )
                ];

                setSelectedAddonOttIds(assigned);
            } else {
                toast.error(
                    res.data.message ||
                    "Unable to load OTT assignments"
                );
            }
        } catch (error) {
            console.error(
                "Addon OTT Assignment Error:",
                error
            );

            setSelectedAddonOttIds([]);

            toast.error(
                error.response?.data?.message ||
                "Unable to load OTT assignments"
            );
        } finally {
            setAddonOttLoading(false);
        }
    };

    const toggleSelectedAddonOtt = (id) => {
        setSelectedAddonOttIds((prev) =>
            prev.includes(Number(id))
                ? prev.filter((ottId) => ottId !== Number(id))
                : [...prev, Number(id)]
        );
    };

    const saveAddonOttAssignments = async () => {
        if (!selectedAddonForOtt?.id) {
            toast.error("OTT add-on plan not selected");
            return;
        }

        try {
            setAddonOttLoading(true);

            /*
             * Normalize the selected IDs before sending them to PHP.
             * This guarantees unique numeric OTT platform IDs.
             */
            const selectedIds = [
                ...new Set(
                    selectedAddonOttIds
                        .map((id) => Number(id))
                        .filter(
                            (id) =>
                                Number.isInteger(id) &&
                                id > 0
                        )
                )
            ];

            const res = await API.post(
                "/save_addon_ott_assignments.php",
                {
                    ott_addon_plan_id:
                        Number(selectedAddonForOtt.id),
                    ott_platform_ids: selectedIds
                }
            );

            if (res.data.status === "success") {
                toast.success(
                    "OTT plan configuration saved successfully"
                );

                /*
                 * Keep the current React state synchronized immediately.
                 * This prevents stale OTT IDs if the same add-on is opened
                 * again before/while the API refresh completes.
                 */
                setOttAddonPlans((prev) =>
                    prev.map((plan) =>
                        Number(plan.id) ===
                            Number(selectedAddonForOtt.id)
                            ? {
                                ...plan,
                                ott_platform_ids:
                                    selectedIds
                            }
                            : plan
                    )
                );

                setSelectedAddonOttIds(selectedIds);
                setShowAddonOttAssignmentModal(false);

                /*
                 * Refresh from the database so the UI remains the
                 * source-of-truth after the save.
                 */
                await fetchOttAddonPlans();
            } else {
                toast.error(
                    res.data.message ||
                    "Unable to save OTT plan configuration"
                );
            }
        } catch (error) {
            console.error(
                "Save Addon OTT Assignment Error:",
                error
            );

            toast.error(
                error.response?.data?.message ||
                "Unable to save OTT plan configuration"
            );
        } finally {
            setAddonOttLoading(false);
        }
    };

    /* =========================================================
       OTT ADDON
    ========================================================= */

    const openAddAddon = () => {
        setEditingAddon(null);
        setAddonForm(emptyAddon);
        clearAddonErrors();
        setShowAddonModal(true);
    };

    const openEditAddon = (addon) => {
        setEditingAddon(addon);

        setAddonForm({
            id: addon.id,
            duration_months:
                addon.duration_months ||
                addon.months ||
                3,
            duration_label:
                addon.duration_label ||
                addon.label ||
                "",
            price: addon.price || "",
            is_popular: Boolean(addon.is_popular),
            badge: addon.badge || "",
            description: addon.description || "",
            display_order:
                addon.display_order || 0,
            active: Boolean(addon.active),
            features:
                addon.features?.length > 0
                    ? addon.features.map(
                        (feature) =>
                            feature.feature_text ||
                            ""
                    )
                    : [""]
        });

        clearAddonErrors();
        setShowAddonModal(true);
    };

    const updateAddonField = (field, value) => {
        setAddonForm((prev) => ({
            ...prev,
            [field]: value
        }));
        // Clear error for this field when user types
        if (addonErrors[field]) {
            setAddonErrors((prev) => ({ ...prev, [field]: false }));
        }
    };

    const addAddonFeature = () => {
        setAddonForm((prev) => ({
            ...prev,
            features: [...prev.features, ""]
        }));
    };

    const removeAddonFeature = (index) => {
        setAddonForm((prev) => ({
            ...prev,
            features: prev.features.filter(
                (_, i) => i !== index
            )
        }));
    };

    const updateAddonFeature = (index, value) => {
        setAddonForm((prev) => ({
            ...prev,
            features: prev.features.map(
                (feature, i) =>
                    i === index ? value : feature
            )
        }));
    };

    const saveAddonPlan = async () => {
        // --- Per-field validation ---
        const errors = {};
        let hasError = false;

        if (!addonForm.duration_label.trim()) {
            errors.duration_label = "Duration label is required";
            hasError = true;
        }

        if (
            addonForm.price === "" ||
            addonForm.price === null ||
            Number(addonForm.price) < 0
        ) {
            errors.price = "A valid price (≥ 0) is required";
            hasError = true;
        }

        if (!addonForm.duration_months || Number(addonForm.duration_months) <= 0) {
            errors.duration_months = "Valid duration in months is required";
            hasError = true;
        }

        if (hasError) {
            setAddonErrors(errors);
            toast.error("Please fill all required fields highlighted in red");
            return;
        }

        setAddonErrors({});

        try {
            setLoading(true);

            const endpoint = editingAddon
                ? "/update_ott_addon_plan.php"
                : "/create_ott_addon_plan.php";

            const payload = {
                ...addonForm,
                duration_months: Number(
                    addonForm.duration_months
                ),
                price: Number(addonForm.price),
                display_order: Number(
                    addonForm.display_order || 0
                ),
                is_popular: Boolean(
                    addonForm.is_popular
                ),
                active: Boolean(addonForm.active),
                features: addonForm.features
                    .map((feature) => feature.trim())
                    .filter(Boolean)
            };

            const res = await API.post(
                endpoint,
                payload
            );

            if (res.data.status === "success") {
                toast.success(
                    editingAddon
                        ? "OTT add-on plan updated successfully"
                        : "OTT add-on plan created successfully"
                );

                setShowAddonModal(false);
                setEditingAddon(null);
                setAddonForm(emptyAddon);

                await fetchOttAddonPlans();
            } else {
                toast.error(
                    res.data.message ||
                    "Unable to save OTT add-on plan"
                );
            }
        } catch (error) {
            console.error(error);
            toast.error(
                error.response?.data?.message ||
                "Unable to save OTT add-on plan"
            );
        } finally {
            setLoading(false);
        }
    };

    const deleteAddonPlan = async (id) => {
        const result = await Swal.fire({
            title: "Delete OTT add-on plan?",
            text: "This action cannot be undone.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it"
        });

        if (!result.isConfirmed) return;

        try {
            setLoading(true);

            const res = await API.post(
                "/delete_ott_addon_plan.php",
                { id }
            );

            if (res.data.status === "success") {
                toast.success(res.data.message);
                await fetchOttAddonPlans();
            }
        } catch (error) {
            console.error(error);
            toast.error(
                "Unable to delete OTT add-on plan"
            );
        } finally {
            setLoading(false);
        }
    };

    const toggleAddonPlan = async (addon) => {
        try {
            setLoading(true);

            const res = await API.post(
                "/toggle_ott_addon_plan.php",
                {
                    id: addon.id,
                    active: addon.active ? 0 : 1
                }
            );

            if (res.data.status === "success") {
                toast.success(res.data.message);
                await fetchOttAddonPlans();
            }
        } catch (error) {
            console.error(error);
            toast.error(
                "Unable to update OTT add-on status"
            );
        } finally {
            setLoading(false);
        }
    };

    /* =========================================================
       FILTERED PLAN DATA
    ========================================================= */

    const matchesPlanFilter = (item) => {
        const searchText =
            planSearch.trim().toLowerCase();

        const statusMatch =
            planStatusFilter === "all" ||
            (planStatusFilter === "active" &&
                Number(item.active) === 1) ||
            (planStatusFilter === "inactive" &&
                Number(item.active) === 0);

        if (!statusMatch) return false;

        if (!searchText) return true;

        return JSON.stringify(item)
            .toLowerCase()
            .includes(searchText);
    };

    const filteredBroadbandPlans =
        broadbandPlans.filter(matchesPlanFilter);

    const filteredOttPlatforms =
        ottPlatforms.filter(matchesPlanFilter);

    const filteredAddonPlans =
        ottAddonPlans.filter(matchesPlanFilter);

    /* =========================================================
       RENDER PLAN STATS
    ========================================================= */

    const activePlanCount = broadbandPlans.filter(
        (plan) => Number(plan.active) === 1
    ).length;

    const activeOttCount = ottPlatforms.filter(
        (ott) => Number(ott.active) === 1
    ).length;

    const activeAddonCount = ottAddonPlans.filter(
        (plan) => Number(plan.active) === 1
    ).length;

    /* =========================================================
       FILTERED PAYMENTS DATA
    ========================================================= */
    const getActivePlanTypeFilter = () => {
        if (paymentTab === "pending") return pendingPlanType;
        if (paymentTab === "active") return activePlanType;
        if (paymentTab === "expired") return expiredPlanType;
        if (paymentTab === "scheduled") return scheduledPlanType;
        return "BROADBAND";
    };

    const getActiveDateFilter = () => {
        if (paymentTab === "pending") return pendingDateFilter;
        if (paymentTab === "active") return activeDateFilter;
        if (paymentTab === "expired") return expiredDateFilter;
        if (paymentTab === "scheduled") return scheduledDateFilter;
        return "week";
    };

    const isWithinDateRange = (dateStr, range) => {
        if (!range || range === "all") return true;
        const date = parseIndiaDateTime(dateStr);
        if (!date) return false;

        const now = new Date();
        /* Start of today in IST — shift to UTC then back */
        const todayIST = new Date(
            now.toLocaleString("en-US", { timeZone: INDIA_TIMEZONE })
        );
        todayIST.setHours(0, 0, 0, 0);

        if (range === "today") {
            const tomorrowIST = new Date(todayIST);
            tomorrowIST.setDate(tomorrowIST.getDate() + 1);
            return date >= todayIST && date < tomorrowIST;
        }
        if (range === "week") {
            const day = todayIST.getDay();
            const startOfWeek = new Date(todayIST);
            startOfWeek.setDate(todayIST.getDate() - day);
            const endOfWeek = new Date(startOfWeek);
            endOfWeek.setDate(startOfWeek.getDate() + 7);
            return date >= startOfWeek && date < endOfWeek;
        }
        if (range === "month") {
            const startOfMonth = new Date(todayIST);
            startOfMonth.setDate(1);
            const endOfMonth = new Date(startOfMonth);
            endOfMonth.setMonth(endOfMonth.getMonth() + 1);
            return date >= startOfMonth && date < endOfMonth;
        }
        if (range === "year") {
            const startOfYear = new Date(todayIST);
            startOfYear.setMonth(0, 1);
            const endOfYear = new Date(startOfYear);
            endOfYear.setFullYear(endOfYear.getFullYear() + 1);
            return date >= startOfYear && date < endOfYear;
        }
        return true;
    };

    const filteredPayments = payments.filter((payment) => {
        const planTypeFilter = getActivePlanTypeFilter();
        const dateRange = getActiveDateFilter();
        const paymentPlanType = String(payment.plan_type || "").toUpperCase();

        const planMatch =
            planTypeFilter === "BROADBAND"
                ? paymentPlanType === "BROADBAND" || paymentPlanType === ""
                : paymentPlanType === "ADDON" || paymentPlanType === "OTT_ADDON";

        const dateMatch = isWithinDateRange(payment.transaction_date, dateRange);

        return planMatch && dateMatch;
    });

    return (
        <>
            <div className="admin-container">
                {loading && <Loader />}

                {/* Header */}
                <div className="admin-header-card">
                    <div className="header-card-inner">
                        <div className="header-title-section">
                            <div className="avatar-glow">
                                <div className="avatar-circle">
                                    <i className="fa-solid fa-shield-halved"></i>
                                </div>
                            </div>

                            <div className="title-text">
                                <span className="welcome-tagline">
                                    RITU BROAD BAND
                                </span>

                                <h2 className="welcome-name">
                                    Admin Control Center
                                </h2>

                                <p className="subtitle-text">
                                    Monitor new customer requests,
                                    manage active subscriptions,
                                    plans, OTT services and secure
                                    financial logs.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Stats */}
                <div className="stats-grid">

                    {activeTab === "requests" && (
                        <>
                            <div className="stat-card">
                                <div className="stat-icon-wrapper requests">
                                    <i className="fa-solid fa-user-plus"></i>
                                </div>

                                <div className="stat-info">
                                    <span className="stat-label">
                                        Pending Requests
                                    </span>

                                    <h3 className="stat-value">
                                        {stats.pending_requests}
                                    </h3>

                                    <p className="stat-description">
                                        New sign-ups awaiting verification
                                    </p>
                                </div>
                            </div>

                            <div className="stat-card">
                                <div className="stat-icon-wrapper users">
                                    <i className="fa-solid fa-users"></i>
                                </div>

                                <div className="stat-info">
                                    <span className="stat-label">
                                        Existing Database Users
                                    </span>

                                    <h3 className="stat-value">
                                        {stats.total_existing_users}
                                    </h3>

                                    <p className="stat-description">
                                        Total customer database capacity
                                    </p>
                                </div>
                            </div>

                            <div className="stat-card">
                                <div className="stat-icon-wrapper active">
                                    <i className="fa-solid fa-circle-check"></i>
                                </div>

                                <div className="stat-info">
                                    <span className="stat-label">
                                        Active Connection Lines
                                    </span>

                                    <h3 className="stat-value">
                                        {stats.active_users}
                                    </h3>

                                    <p className="stat-description">
                                        Customers currently online on fiber
                                    </p>
                                </div>
                            </div>
                        </>
                    )}

                    {activeTab === "existing" && (
                        <>
                            <div className="stat-card">
                                <div className="stat-icon-wrapper users">
                                    <i className="fa-solid fa-users"></i>
                                </div>

                                <div className="stat-info">
                                    <span className="stat-label">
                                        Total Registered Customers
                                    </span>

                                    <h3 className="stat-value">
                                        {stats.total_existing_users}
                                    </h3>

                                    <p className="stat-description">
                                        Overall verified subscriber accounts
                                    </p>
                                </div>
                            </div>

                            <div className="stat-card">
                                <div className="stat-icon-wrapper active">
                                    <i className="fa-solid fa-circle-check"></i>
                                </div>

                                <div className="stat-info">
                                    <span className="stat-label">
                                        Active Connections
                                    </span>

                                    <h3 className="stat-value">
                                        {stats.active_users}
                                    </h3>

                                    <p className="stat-description">
                                        Customers currently online on fiber
                                    </p>
                                </div>
                            </div>

                            <div className="stat-card">
                                <div className="stat-icon-wrapper inactive">
                                    <i className="fa-solid fa-triangle-exclamation"></i>
                                </div>

                                <div className="stat-info">
                                    <span className="stat-label">
                                        Inactive Suspended Lines
                                    </span>

                                    <h3 className="stat-value">
                                        {stats.inactive_users}
                                    </h3>

                                    <p className="stat-description">
                                        Accounts suspended or disconnected
                                    </p>
                                </div>
                            </div>
                        </>
                    )}

                    {activeTab === "payments" && (
                        <>
                            <div className="stat-card">
                                <div className="stat-icon-wrapper payments-today">
                                    <i className="fa-solid fa-calendar-day"></i>
                                </div>

                                <div className="stat-info">
                                    <span className="stat-label">
                                        Today's Completed Payments
                                    </span>

                                    <h3 className="stat-value">
                                        {stats.payments_today_completed}
                                    </h3>

                                    <p className="stat-description">
                                        Successful transactions logged today
                                    </p>
                                </div>
                            </div>

                            <div className="stat-card">
                                <div className="stat-icon-wrapper active">
                                    <i className="fa-solid fa-shield-halved"></i>
                                </div>

                                <div className="stat-info">
                                    <span className="stat-label">
                                        Active Broad Band Plans
                                    </span>

                                    <h3 className="stat-value">
                                        {stats.active_plans}
                                    </h3>

                                    <p className="stat-description">
                                        Subscriptions currently in validity
                                    </p>
                                </div>
                            </div>

                            <div className="stat-card">
                                <div className="stat-icon-wrapper inactive">
                                    <i className="fa-solid fa-circle-exclamation"></i>
                                </div>

                                <div className="stat-info">
                                    <span className="stat-label">
                                        Expired Broad Band Plans
                                    </span>

                                    <h3 className="stat-value">
                                        {stats.expired_plans}
                                    </h3>

                                    <p className="stat-description">
                                        Customers with lapsed validity dates
                                    </p>
                                </div>
                            </div>
                        </>
                    )}

                    {activeTab === "plans" && (
                        <>
                            <div className="stat-card">
                                <div className="stat-icon-wrapper requests">
                                    <i className="fa-solid fa-wifi"></i>
                                </div>

                                <div className="stat-info">
                                    <span className="stat-label">
                                        Broad Band Plans
                                    </span>

                                    <h3 className="stat-value">
                                        {broadbandPlans.length}
                                    </h3>

                                    <p className="stat-description">
                                        {activePlanCount} active plans
                                    </p>
                                </div>
                            </div>

                            <div className="stat-card">
                                <div className="stat-icon-wrapper active">
                                    <i className="fa-solid fa-tv"></i>
                                </div>

                                <div className="stat-info">
                                    <span className="stat-label">
                                        OTT Platforms
                                    </span>

                                    <h3 className="stat-value">
                                        {ottPlatforms.length}
                                    </h3>

                                    <p className="stat-description">
                                        {activeOttCount} active platforms
                                    </p>
                                </div>
                            </div>

                            <div className="stat-card">
                                <div className="stat-icon-wrapper payments-today">
                                    <i className="fa-solid fa-film"></i>
                                </div>

                                <div className="stat-info">
                                    <span className="stat-label">
                                        OTT Add-on Plans
                                    </span>

                                    <h3 className="stat-value">
                                        {ottAddonPlans.length}
                                    </h3>

                                    <p className="stat-description">
                                        {activeAddonCount} active add-ons
                                    </p>
                                </div>
                            </div>
                        </>
                    )}
                </div>

                {/* Main Tabs */}
                <div className="tabs">

                    <button
                        className={
                            activeTab === "requests"
                                ? "active"
                                : ""
                        }
                        onClick={() => {
                            setActiveTab("requests");
                            setFilter("");
                            setSearch("");
                            setPage(1);
                        }}
                    >
                        <i className="fa-solid fa-user-plus tab-icon"></i>
                        Request Users
                    </button>

                    <button
                        className={
                            activeTab === "existing"
                                ? "active"
                                : ""
                        }
                        onClick={() => {
                            setActiveTab("existing");
                            setFilter("");
                            setSearch("");
                            setPage(1);
                        }}
                    >
                        <i className="fa-solid fa-users tab-icon"></i>
                        Existing Users
                    </button>

                    <button
                        className={
                            activeTab === "payments"
                                ? "active"
                                : ""
                        }
                        onClick={() => {
                            setActiveTab("payments");
                            setPaymentTab("pending");
                            setFilter("");
                            setSearch("");
                            setPage(1);
                        }}
                    >
                        <i className="fa-solid fa-credit-card tab-icon"></i>
                        Payments
                    </button>

                    <button
                        className={
                            activeTab === "plans"
                                ? "active"
                                : ""
                        }
                        onClick={() => {
                            setActiveTab("plans");
                            setPlanTab("broadband");
                            setPlanSearch("");
                            setPlanStatusFilter("all");
                        }}
                    >
                        <i className="fa-solid fa-layer-group tab-icon"></i>
                        Manage Plans
                    </button>
                </div>

                {/* =====================================================
                    MANAGE PLANS
                ===================================================== */}

                {activeTab === "plans" ? (
                    <div className="plan-management-section">

                        <div className="plan-management-banner">
                            <div className="plan-banner-icon">
                                <i className="fa-solid fa-layer-group"></i>
                            </div>

                            <div>
                                <h3>
                                    Manage Broad Band & OTT Plans
                                </h3>

                                <p>
                                    Add, edit, activate, disable and
                                    manage all Broad Band and OTT plans
                                    from one place.
                                </p>
                            </div>
                        </div>

                        {/* Plan Sub Tabs */}

                        <div className="plan-sub-tabs">

                            <button
                                className={
                                    planTab === "broadband"
                                        ? "active"
                                        : ""
                                }
                                onClick={() =>
                                    setPlanTab("broadband")
                                }
                            >
                                <i className="fa-solid fa-wifi"></i>
                                Broad Band Plans
                            </button>

                            <button
                                className={
                                    planTab === "ott"
                                        ? "active"
                                        : ""
                                }
                                onClick={() =>
                                    setPlanTab("ott")
                                }
                            >
                                <i className="fa-solid fa-tv"></i>
                                OTT Platforms
                            </button>

                            <button
                                className={
                                    planTab === "addon"
                                        ? "active"
                                        : ""
                                }
                                onClick={() =>
                                    setPlanTab("addon")
                                }
                            >
                                <i className="fa-solid fa-film"></i>
                                OTT Add-on Plans
                            </button>

                        </div>

                        {/* Search Toolbar */}

                        <div className="filters-container">

                            <div className="search-wrapper">
                                <i className="fa-solid fa-magnifying-glass search-icon"></i>

                                <input
                                    type="text"
                                    placeholder={
                                        planTab === "broadband"
                                            ? "Search broad band plans..."
                                            : planTab === "ott"
                                                ? "Search OTT platforms..."
                                                : "Search OTT add-on plans..."
                                    }
                                    value={planSearch}
                                    onChange={(e) =>
                                        setPlanSearch(
                                            e.target.value
                                        )
                                    }
                                />
                            </div>

                            <div className="select-wrapper">
                                <select
                                    value={planStatusFilter}
                                    onChange={(e) =>
                                        setPlanStatusFilter(
                                            e.target.value
                                        )
                                    }
                                >
                                    <option value="all">
                                        All Status
                                    </option>

                                    <option value="active">
                                        Active
                                    </option>

                                    <option value="inactive">
                                        Inactive
                                    </option>
                                </select>
                            </div>

                            {planTab === "broadband" && (
                                <button
                                    className="admin-register-btn"
                                    onClick={openAddPlan}
                                >
                                    <i className="fa-solid fa-plus"></i>
                                    Add Broad Band Plan
                                </button>
                            )}

                            {planTab === "ott" && (
                                <button
                                    className="admin-register-btn"
                                    onClick={openAddOtt}
                                >
                                    <i className="fa-solid fa-plus"></i>
                                    Add OTT Platform
                                </button>
                            )}

                            {planTab === "addon" && (
                                <button
                                    className="admin-register-btn"
                                    onClick={openAddAddon}
                                >
                                    <i className="fa-solid fa-plus"></i>
                                    Add OTT Add-on
                                </button>
                            )}

                        </div>

                        {/* =================================================
                            BROADBAND PLANS
                        ================================================= */}

                        {planTab === "broadband" && (
                            <div className="plan-management-grid">

                                {filteredBroadbandPlans.length ===
                                    0 ? (
                                    <div className="plan-empty-state">
                                        <i className="fa-solid fa-wifi"></i>

                                        <h3>
                                            No broad band plans found
                                        </h3>

                                        <p>
                                            Add your first broad band
                                            plan to get started.
                                        </p>

                                        <button
                                            className="admin-register-btn"
                                            onClick={openAddPlan}
                                        >
                                            <i className="fa-solid fa-plus"></i>
                                            Add Broad Band Plan
                                        </button>
                                    </div>
                                ) : (
                                    filteredBroadbandPlans.map(
                                        (plan) => (
                                            <div
                                                className="managed-plan-card"
                                                key={plan.id}
                                            >

                                                <div className="managed-plan-header">

                                                    <div className="managed-speed">
                                                        <strong>
                                                            {plan.speed}
                                                        </strong>

                                                        <span>
                                                            Mbps
                                                        </span>
                                                    </div>

                                                    <div className="managed-plan-title">
                                                        <h3>
                                                            {
                                                                plan.plan_name
                                                            }
                                                        </h3>

                                                        <p>
                                                            {
                                                                plan.tagline
                                                            }
                                                        </p>
                                                    </div>

                                                    <span
                                                        className={`status-badge ${Number(
                                                            plan.active
                                                        ) === 1
                                                            ? "active"
                                                            : "inactive"
                                                            }`}
                                                    >
                                                        <span className="badge-dot"></span>

                                                        {Number(
                                                            plan.active
                                                        ) === 1
                                                            ? "Active"
                                                            : "Inactive"}
                                                    </span>
                                                </div>

                                                <div className="managed-plan-meta">

                                                    {Number(
                                                        plan.is_popular
                                                    ) === 1 && (
                                                            <span className="popular-plan-badge">
                                                                <i className="fa-solid fa-star"></i>
                                                                Popular
                                                            </span>
                                                        )}

                                                    <span>
                                                        <i className="fa-solid fa-list"></i>
                                                        {
                                                            plan.durations
                                                                ?.length
                                                        }{" "}
                                                        Durations
                                                    </span>

                                                    <span>
                                                        <i className="fa-solid fa-list-check"></i>
                                                        {
                                                            plan.features
                                                                ?.length
                                                        }{" "}
                                                        Features
                                                    </span>

                                                </div>

                                                <div className="duration-preview">

                                                    <h4>
                                                        Plan Durations
                                                    </h4>

                                                    <div className="duration-preview-grid">

                                                        {plan.durations?.map(
                                                            (
                                                                duration
                                                            ) => (
                                                                <div
                                                                    className="duration-preview-card"
                                                                    key={
                                                                        duration.id
                                                                    }
                                                                >
                                                                    <span>
                                                                        {
                                                                            duration.label
                                                                        }
                                                                    </span>

                                                                    <strong>
                                                                        ₹
                                                                        {Number(
                                                                            duration.price
                                                                        ).toLocaleString(
                                                                            "en-IN"
                                                                        )}
                                                                    </strong>

                                                                    {duration.badge && (
                                                                        <small>
                                                                            {
                                                                                duration.badge
                                                                            }
                                                                        </small>
                                                                    )}
                                                                </div>
                                                            )
                                                        )}

                                                    </div>
                                                </div>

                                                <div className="managed-plan-actions">

                                                    <button
                                                        className="plan-action primary"
                                                        onClick={() =>
                                                            openEditPlan(
                                                                plan
                                                            )
                                                        }
                                                    >
                                                        <i className="fa-solid fa-pen"></i>
                                                        Edit
                                                    </button>

                                                    <button
                                                        className="plan-action ott"
                                                        onClick={() => {
                                                            if (
                                                                !plan
                                                                    .durations
                                                                    ?.length
                                                            ) {
                                                                toast.error(
                                                                    "This plan has no durations"
                                                                );
                                                                return;
                                                            }

                                                            openOttAssignment(
                                                                plan,
                                                                plan.durations[0]
                                                            );
                                                        }}
                                                    >
                                                        <i className="fa-solid fa-tv"></i>
                                                        Manage OTTs
                                                    </button>

                                                    <button
                                                        className="plan-action warning"
                                                        onClick={() =>
                                                            toggleBroadbandPlan(
                                                                plan
                                                            )
                                                        }
                                                    >
                                                        <i
                                                            className={`fa-solid ${Number(
                                                                plan.active
                                                            ) === 1
                                                                ? "fa-ban"
                                                                : "fa-circle-check"
                                                                }`}
                                                        ></i>

                                                        {Number(
                                                            plan.active
                                                        ) === 1
                                                            ? "Disable"
                                                            : "Enable"}
                                                    </button>

                                                    <button
                                                        className="plan-action danger"
                                                        onClick={() =>
                                                            deleteBroadbandPlan(
                                                                plan.id
                                                            )
                                                        }
                                                    >
                                                        <i className="fa-solid fa-trash"></i>
                                                        Delete
                                                    </button>

                                                </div>
                                            </div>
                                        )
                                    )
                                )}

                            </div>
                        )}

                        {/* =================================================
                            OTT PLATFORMS
                        ================================================= */}

                        {planTab === "ott" && (
                            <div className="plan-management-grid">

                                {filteredOttPlatforms.length ===
                                    0 ? (
                                    <div className="plan-empty-state">

                                        <i className="fa-solid fa-tv"></i>

                                        <h3>
                                            No OTT platforms found
                                        </h3>

                                        <p>
                                            Add your first OTT platform.
                                        </p>

                                        <button
                                            className="admin-register-btn"
                                            onClick={openAddOtt}
                                        >
                                            <i className="fa-solid fa-plus"></i>
                                            Add OTT Platform
                                        </button>

                                    </div>
                                ) : (
                                    filteredOttPlatforms.map(
                                        (ott) => (
                                            <div
                                                className="ott-managed-card"
                                                key={ott.id}
                                            >

                                                <div className="ott-managed-logo">

                                                    {ott.logo ? (
                                                        <img
                                                            src={ott.logo}
                                                            alt={
                                                                ott.ott_name ||
                                                                ott.name
                                                            }
                                                        />
                                                    ) : (
                                                        <i className="fa-solid fa-tv"></i>
                                                    )}

                                                </div>

                                                <div className="ott-managed-info">

                                                    <h3>
                                                        {
                                                            ott.ott_name
                                                        }
                                                    </h3>

                                                    <span
                                                        className={`status-badge ${Number(
                                                            ott.active
                                                        ) === 1
                                                            ? "active"
                                                            : "inactive"
                                                            }`}
                                                    >
                                                        <span className="badge-dot"></span>

                                                        {Number(
                                                            ott.active
                                                        ) === 1
                                                            ? "Active"
                                                            : "Inactive"}
                                                    </span>

                                                </div>

                                                <div className="managed-card-actions">

                                                    <button
                                                        className="action-btn reminder"
                                                        title="Edit"
                                                        onClick={() =>
                                                            openEditOtt(
                                                                ott
                                                            )
                                                        }
                                                    >
                                                        <i className="fa-solid fa-pen"></i>
                                                    </button>

                                                    <button
                                                        className="action-btn reminder"
                                                        title={
                                                            Number(
                                                                ott.active
                                                            ) === 1
                                                                ? "Disable"
                                                                : "Enable"
                                                        }
                                                        onClick={() =>
                                                            toggleOttPlatform(
                                                                ott
                                                            )
                                                        }
                                                    >
                                                        <i
                                                            className={`fa-solid ${Number(
                                                                ott.active
                                                            ) === 1
                                                                ? "fa-ban"
                                                                : "fa-circle-check"
                                                                }`}
                                                        ></i>
                                                    </button>

                                                    <button
                                                        className="action-btn delete"
                                                        title="Delete"
                                                        onClick={() =>
                                                            deleteOttPlatform(
                                                                ott.id
                                                            )
                                                        }
                                                    >
                                                        <i className="fa-solid fa-trash"></i>
                                                    </button>

                                                </div>

                                            </div>
                                        )
                                    )
                                )}

                            </div>
                        )}

                        {/* =================================================
                            OTT ADDON PLANS
                        ================================================= */}

                        {planTab === "addon" && (
                            <div className="plan-management-grid">

                                {filteredAddonPlans.length ===
                                    0 ? (
                                    <div className="plan-empty-state">

                                        <i className="fa-solid fa-film"></i>

                                        <h3>
                                            No OTT add-on plans found
                                        </h3>

                                        <p>
                                            Add your first OTT add-on
                                            subscription.
                                        </p>

                                        <button
                                            className="admin-register-btn"
                                            onClick={openAddAddon}
                                        >
                                            <i className="fa-solid fa-plus"></i>
                                            Add OTT Add-on
                                        </button>

                                    </div>
                                ) : (
                                    filteredAddonPlans.map(
                                        (addon) => (
                                            <div
                                                className="managed-plan-card"
                                                key={addon.id}
                                            >

                                                <div className="managed-plan-header">

                                                    <div className="managed-speed">
                                                        <strong>
                                                            {
                                                                addon.duration_months
                                                            }
                                                        </strong>

                                                        <span>
                                                            Months
                                                        </span>
                                                    </div>

                                                    <div className="managed-plan-title">

                                                        <h3>
                                                            {
                                                                addon.duration_label
                                                            }
                                                        </h3>

                                                        <p>
                                                            {
                                                                addon.description
                                                            }
                                                        </p>

                                                    </div>

                                                    <span
                                                        className={`status-badge ${Number(
                                                            addon.active
                                                        ) === 1
                                                            ? "active"
                                                            : "inactive"
                                                            }`}
                                                    >
                                                        <span className="badge-dot"></span>

                                                        {Number(
                                                            addon.active
                                                        ) === 1
                                                            ? "Active"
                                                            : "Inactive"}
                                                    </span>

                                                </div>

                                                <div className="addon-price-display">

                                                    <span>
                                                        Plan Price
                                                    </span>

                                                    <strong>
                                                        ₹
                                                        {Number(
                                                            addon.price
                                                        ).toLocaleString(
                                                            "en-IN"
                                                        )}
                                                    </strong>

                                                </div>

                                                {addon.badge && (
                                                    <span className="popular-plan-badge">
                                                        <i className="fa-solid fa-tag"></i>
                                                        {addon.badge}
                                                    </span>
                                                )}

                                                <div className="addon-feature-list">

                                                    {addon.features
                                                        ?.slice(
                                                            0,
                                                            4
                                                        )
                                                        .map(
                                                            (
                                                                feature
                                                            ) => (
                                                                <span
                                                                    key={
                                                                        feature.id
                                                                    }
                                                                >
                                                                    <i className="fa-solid fa-check"></i>
                                                                    {
                                                                        feature.feature_text
                                                                    }
                                                                </span>
                                                            )
                                                        )}

                                                </div>

                                                <div className="managed-plan-actions">

                                                    <button
                                                        className="plan-action primary"
                                                        onClick={() =>
                                                            openEditAddon(
                                                                addon
                                                            )
                                                        }
                                                    >
                                                        <i className="fa-solid fa-pen"></i>
                                                        Edit
                                                    </button>

                                                    <button
                                                        className="plan-action ott"
                                                        onClick={() =>
                                                            openAddonOttAssignment(
                                                                addon
                                                            )
                                                        }
                                                    >
                                                        <i className="fa-solid fa-tv"></i>
                                                        Manage OTT Plans
                                                    </button>

                                                    <button
                                                        className="plan-action warning"
                                                        onClick={() =>
                                                            toggleAddonPlan(
                                                                addon
                                                            )
                                                        }
                                                    >
                                                        <i
                                                            className={`fa-solid ${Number(
                                                                addon.active
                                                            ) === 1
                                                                ? "fa-ban"
                                                                : "fa-circle-check"
                                                                }`}
                                                        ></i>

                                                        {Number(
                                                            addon.active
                                                        ) === 1
                                                            ? "Disable"
                                                            : "Enable"}
                                                    </button>

                                                    <button
                                                        className="plan-action danger"
                                                        onClick={() =>
                                                            deleteAddonPlan(
                                                                addon.id
                                                            )
                                                        }
                                                    >
                                                        <i className="fa-solid fa-trash"></i>
                                                        Delete
                                                    </button>

                                                </div>

                                            </div>
                                        )
                                    )
                                )}

                            </div>
                        )}
                    </div>
                ) : (
                    <>
                        {/* =====================================================
                            PAYMENT SUB TABS
                        ===================================================== */}

                        {/* {activeTab === "payments" && (
                            <div className="payment-sub-tabs">

                                <button
                                    type="button"
                                    className={paymentTab === "pending" ? "active" : ""}
                                    onClick={() => {
                                        setPaymentTab("pending");
                                        setFilter("");
                                        setPage(1);
                                    }}
                                >
                                    <i className="fa-solid fa-clock"></i>
                                    <span>Pending</span>
                                </button>

                                <button
                                    type="button"
                                    className={paymentTab === "active" ? "active" : ""}
                                    onClick={() => {
                                        setPaymentTab("active");
                                        setFilter("");
                                        setPage(1);
                                    }}
                                >
                                    <i className="fa-solid fa-circle-check"></i>
                                    <span>Active Plans</span>
                                </button>

                                <button
                                    type="button"
                                    className={paymentTab === "expired" ? "active" : ""}
                                    onClick={() => {
                                        setPaymentTab("expired");
                                        setFilter("");
                                        setPage(1);
                                    }}
                                >
                                    <i className="fa-solid fa-circle-exclamation"></i>
                                    <span>Expired Plans</span>
                                </button>

                            </div>
                        )} */}
                        {activeTab === "payments" && (
                            <div className="payment-sub-tabs">

                                {/* PENDING */}
                                <button
                                    type="button"
                                    className={
                                        paymentTab === "pending"
                                            ? "active"
                                            : ""
                                    }
                                    onClick={() => {
                                        setPaymentTab("pending");
                                        setFilter("");
                                        setPage(1);
                                    }}
                                >
                                    <i className="fa-solid fa-clock"></i>
                                    <span>Pending</span>
                                </button>


                                {/* ACTIVE */}
                                <button
                                    type="button"
                                    className={
                                        paymentTab === "active"
                                            ? "active"
                                            : ""
                                    }
                                    onClick={() => {
                                        setPaymentTab("active");
                                        setFilter("");
                                        setPage(1);
                                    }}
                                >
                                    <i className="fa-solid fa-circle-check"></i>
                                    <span>Active Plans</span>
                                </button>


                                {/* EXPIRED */}
                                <button
                                    type="button"
                                    className={
                                        paymentTab === "expired"
                                            ? "active"
                                            : ""
                                    }
                                    onClick={() => {
                                        setPaymentTab("expired");
                                        setFilter("");
                                        setPage(1);
                                    }}
                                >
                                    <i className="fa-solid fa-circle-exclamation"></i>
                                    <span>Expired Plans</span>
                                </button>


                                {/* SCHEDULED */}
                                <button
                                    type="button"
                                    className={
                                        paymentTab === "scheduled"
                                            ? "active"
                                            : ""
                                    }
                                    onClick={() => {
                                        setPaymentTab("scheduled");
                                        setFilter("");
                                        setPage(1);
                                    }}
                                >
                                    <i className="fa-solid fa-calendar-days"></i>
                                    <span>Scheduled</span>
                                </button>

                            </div>
                        )}
                        {activeTab === "payments" && (
                            <div className="payment-tab-heading">
                                <div>
                                    <h3>
                                        {paymentTab === "pending" && "Pending Plan Activations"}
                                        {paymentTab === "active" && "Active Broadband Plans"}
                                        {paymentTab === "expired" && "Expired Broadband Plans"}
                                        {paymentTab === "scheduled" &&
                                            "Scheduled Broadband Plans"
                                        }
                                    </h3>
                                    <p>
                                        {paymentTab === "pending" && "Successful payments waiting for admin activation."}
                                        {paymentTab === "active" && "Broadband plans currently active."}
                                        {paymentTab === "expired" && "Broadband plans whose validity period has ended."}
                                        {paymentTab === "scheduled" &&
                                            "Broadband plans scheduled for activation."
                                        }
                                    </p>
                                </div>
                                <span className={`payment-section-status ${paymentTab}`}>
                                    <span className="badge-dot"></span>
                                    {paymentTab === "pending" && "Awaiting Activation"}
                                    {paymentTab === "active" && "Currently Active"}
                                    {paymentTab === "expired" && "Expired"}
                                    {paymentTab === "scheduled" &&
                                        "Scheduled"
                                    }
                                </span>
                            </div>
                        )}

                        {/* Existing Search / Filters */}

                        <div className="filters-container">

                            <div className="search-wrapper">
                                <i className="fa-solid fa-magnifying-glass search-icon"></i>

                                <input
                                    type="text"
                                    placeholder="Search users, transactions, plans..."
                                    value={search}
                                    onChange={(e) => {
                                        setSearch(
                                            e.target.value
                                        );
                                        setPage(1);
                                    }}
                                />
                            </div>

                            {activeTab === "existing" && (
                                <button
                                    className="admin-register-btn"
                                    onClick={() =>
                                        setShowRegisterModal(
                                            true
                                        )
                                    }
                                >
                                    <i className="fa-solid fa-user-plus"></i>
                                    Register New Account
                                </button>
                            )}

                            {activeTab === "existing" && (
                                <div className="select-wrapper">

                                    <select
                                        value={filter}
                                        onChange={(e) => {
                                            setFilter(
                                                e.target.value
                                            );
                                            setPage(1);
                                        }}
                                    >
                                        <option value="">
                                            All Statuses
                                        </option>

                                        <option value="active">
                                            Active Connection
                                        </option>

                                        <option value="inactive">
                                            Inactive Connection
                                        </option>
                                    </select>

                                </div>
                            )}

                            {activeTab === "requests" && (
                                <div className="select-wrapper">

                                    <select
                                        value={filter}
                                        onChange={(e) => {
                                            setFilter(
                                                e.target.value
                                            );
                                            setPage(1);
                                        }}
                                    >
                                        <option value="">
                                            All Sign-ups
                                        </option>

                                        <option value="today">
                                            Today
                                        </option>

                                        <option value="weekly">
                                            Weekly
                                        </option>

                                        <option value="monthly">
                                            Monthly
                                        </option>
                                    </select>

                                </div>
                            )}

                            {activeTab === "payments" && paymentTab === "pending" && (
                                <>
                                    <div className="select-wrapper">
                                        <select
                                            value={pendingPlanType}
                                            onChange={(e) => {
                                                setPendingPlanType(e.target.value);
                                                setPage(1);
                                            }}
                                        >
                                            <option value="BROADBAND">Broadband Plan</option>
                                            <option value="ADDON">Add-on Plan</option>
                                        </select>
                                    </div>
                                    <div className="select-wrapper">
                                        <select
                                            value={pendingDateFilter}
                                            onChange={(e) => {
                                                setPendingDateFilter(e.target.value);
                                                setPage(1);
                                            }}
                                        >
                                            <option value="all">All Time</option>
                                            <option value="today">Today</option>
                                            <option value="week">This Week</option>
                                            <option value="month">This Month</option>
                                            <option value="year">This Year</option>
                                        </select>
                                    </div>
                                </>
                            )}

                            {activeTab === "payments" && paymentTab === "active" && (
                                <>
                                    <div className="select-wrapper">
                                        <select
                                            value={activePlanType}
                                            onChange={(e) => {
                                                setActivePlanType(e.target.value);
                                                setPage(1);
                                            }}
                                        >
                                            <option value="BROADBAND">Broadband Plan</option>
                                            <option value="ADDON">Add-on Plan</option>
                                        </select>
                                    </div>
                                    <div className="select-wrapper">
                                        <select
                                            value={activeDateFilter}
                                            onChange={(e) => {
                                                setActiveDateFilter(e.target.value);
                                                setPage(1);
                                            }}
                                        >
                                            <option value="all">All Time</option>
                                            <option value="today">Today</option>
                                            <option value="week">This Week</option>
                                            <option value="month">This Month</option>
                                            <option value="year">This Year</option>
                                        </select>
                                    </div>
                                </>
                            )}

                            {activeTab === "payments" && paymentTab === "expired" && (
                                <>
                                    <div className="select-wrapper">
                                        <select
                                            value={expiredPlanType}
                                            onChange={(e) => {
                                                setExpiredPlanType(e.target.value);
                                                setPage(1);
                                            }}
                                        >
                                            <option value="BROADBAND">Broadband Plan</option>
                                            <option value="ADDON">Add-on Plan</option>
                                        </select>
                                    </div>
                                    <div className="select-wrapper">
                                        <select
                                            value={expiredDateFilter}
                                            onChange={(e) => {
                                                setExpiredDateFilter(e.target.value);
                                                setPage(1);
                                            }}
                                        >
                                            <option value="all">All Time</option>
                                            <option value="today">Today</option>
                                            <option value="week">This Week</option>
                                            <option value="month">This Month</option>
                                            <option value="year">This Year</option>
                                        </select>
                                    </div>
                                </>
                            )}

                            {activeTab === "payments" && paymentTab === "scheduled" && (
                                <>
                                    <div className="select-wrapper">
                                        <select
                                            value={scheduledPlanType}
                                            onChange={(e) => {
                                                setScheduledPlanType(e.target.value);
                                                setPage(1);
                                            }}
                                        >
                                            <option value="BROADBAND">Broadband Plan</option>
                                            <option value="ADDON">Add-on Plan</option>
                                        </select>
                                    </div>
                                    <div className="select-wrapper">
                                        <select
                                            value={scheduledDateFilter}
                                            onChange={(e) => {
                                                setScheduledDateFilter(e.target.value);
                                                setPage(1);
                                            }}
                                        >
                                            <option value="all">All Time</option>
                                            <option value="today">Today</option>
                                            <option value="week">This Week</option>
                                            <option value="month">This Month</option>
                                            <option value="year">This Year</option>
                                        </select>
                                    </div>
                                </>
                            )}

                        </div>

                        {/* Existing Tables */}

                        <div className="table-container">

                            <div className="table-wrapper">

                                <table className="admin-table">

                                    <thead>

                                        {activeTab ===
                                            "existing" ? (
                                            <tr>
                                                <th>Full Name</th>
                                                <th>Username</th>
                                                <th>Email</th>
                                                <th>Mobile</th>
                                                <th>City</th>
                                                <th>Address</th>
                                                <th>Pincode</th>
                                                <th>Created Date</th>
                                                <th>Status</th>
                                                <th>Broadband Payment</th>
                                                <th>Actions</th>
                                            </tr>
                                        ) : activeTab ===
                                            "requests" ? (
                                            <tr>
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>Mobile</th>
                                                <th>City</th>
                                                <th>Address</th>
                                                <th>Pincode</th>
                                                <th>Created Date</th>
                                                <th>Status</th>
                                                <th>Registration</th>
                                                <th>Actions</th>
                                            </tr>
                                        ) : (
                                            <tr>
                                                <th>
                                                    Customer Name
                                                </th>
                                                <th>
                                                    Username
                                                </th>
                                                <th>Email</th>
                                                <th>Mobile</th>
                                                <th>Plan Name</th>
                                                <th>Amount</th>
                                                <th>
                                                    Payment Method
                                                </th>
                                                <th>
                                                    Razorpay Order ID
                                                </th>
                                                <th>
                                                    Razorpay Payment ID
                                                </th>
                                                <th>
                                                    Payment Status
                                                </th>
                                                <th>
                                                    Plan Status
                                                </th>
                                                <th>
                                                    Plan Start Date
                                                </th>
                                                <th>
                                                    Plan Expiry Date
                                                </th>
                                                <th>
                                                    Transaction Date
                                                </th>
                                                <th>
                                                    Last Reminder Date
                                                </th>
                                                <th>Actions</th>
                                            </tr>
                                        )}

                                    </thead>

                                    <tbody>

                                        {activeTab ===
                                            "payments" ? (
                                            filteredPayments.length ===
                                                0 ? (
                                                <tr>
                                                    <td colSpan="16">
                                                        No Data Found
                                                    </td>
                                                </tr>
                                            ) : (
                                                filteredPayments.map(
                                                    (
                                                        payment
                                                    ) => (
                                                        <tr
                                                            key={
                                                                payment.id ||
                                                                payment.razorpay_payment_id ||
                                                                payment.razorpay_order_id
                                                            }
                                                        >

                                                            <td
                                                                style={{
                                                                    textTransform:
                                                                        "capitalize"
                                                                }}
                                                            >
                                                                {
                                                                    payment.customer_name
                                                                }
                                                            </td>

                                                            <td>
                                                                {
                                                                    payment.username
                                                                }
                                                            </td>

                                                            <td>
                                                                {
                                                                    payment.email
                                                                }
                                                            </td>

                                                            <td>
                                                                {
                                                                    payment.mobile
                                                                }
                                                            </td>

                                                            <td>
                                                                {
                                                                    payment.plan_name
                                                                }
                                                            </td>

                                                            <td>
                                                                ₹
                                                                {
                                                                    payment.amount
                                                                }
                                                            </td>

                                                            <td>
                                                                {
                                                                    payment.payment_method ||
                                                                    "ONLINE"
                                                                }
                                                            </td>

                                                            <td>
                                                                {
                                                                    payment.razorpay_order_id
                                                                }
                                                            </td>

                                                            <td>
                                                                {
                                                                    payment.razorpay_payment_id
                                                                }
                                                            </td>

                                                            <td>
                                                                <span
                                                                    className={`payment-badge ${(
                                                                        payment.payment_status ||
                                                                        ""
                                                                    ).toLowerCase()}`}
                                                                >
                                                                    <span className="badge-dot"></span>
                                                                    {
                                                                        payment.payment_status
                                                                    }
                                                                </span>
                                                            </td>

                                                            <td>
                                                                <span
                                                                    className={`plan-badge ${(
                                                                        payment.plan_status ||
                                                                        ""
                                                                    ).toLowerCase()}`}
                                                                >
                                                                    <span className="badge-dot"></span>
                                                                    {
                                                                        payment.plan_status
                                                                    }
                                                                </span>
                                                            </td>

                                                            <td>
                                                                {paymentTab === "pending"
                                                                    ? "Not Activated"
                                                                    : formatDate(payment.plan_start_date)}
                                                            </td>

                                                            <td>
                                                                {paymentTab === "pending"
                                                                    ? "Not Activated"
                                                                    : formatDate(payment.plan_expiry_date)}
                                                            </td>

                                                            <td>
                                                                {formatDate(
                                                                    payment.transaction_date
                                                                )}
                                                            </td>

                                                            <td>
                                                                {formatDate(
                                                                    payment.last_reminder_date
                                                                )}
                                                            </td>

                                                            <td>
                                                                <div className="payment-actions">
                                                                    {paymentTab === "pending" && (
                                                                        <button
                                                                            type="button"
                                                                            className="payment-activate-btn"
                                                                            onClick={() => activatePlan(payment)}
                                                                            disabled={activatingPlanId === payment.id}
                                                                            title="Activate Plan"
                                                                        >
                                                                            {activatingPlanId === payment.id ? (
                                                                                <>
                                                                                    <i className="fa-solid fa-spinner fa-spin"></i>
                                                                                    Activating...
                                                                                </>
                                                                            ) : (
                                                                                <>
                                                                                    <i className="fa-solid fa-power-off"></i>
                                                                                    Activate Plan
                                                                                </>
                                                                            )}
                                                                        </button>
                                                                    )}
                                                                    {(paymentTab === "active" || paymentTab === "scheduled") && (
                                                                        <button
                                                                            type="button"
                                                                            className="payment-edit-btn"
                                                                            onClick={() =>
                                                                                editPlanDates(payment)
                                                                            }
                                                                            title="Edit Plan Dates"
                                                                        >
                                                                            <i className="fa-solid fa-pen"></i>
                                                                        </button>
                                                                    )}
                                                                    {/* {paymentTab === "scheduled" && (
                                                                        <button
                                                                            type="button"
                                                                            className="payment-activate-btn"
                                                                            onClick={() => activatePlan(payment)}
                                                                            disabled={activatingPlanId === payment.id}
                                                                            title="Activate Plan"
                                                                        >
                                                                            {activatingPlanId === payment.id ? (
                                                                                <>
                                                                                    <i className="fa-solid fa-spinner fa-spin"></i>
                                                                                    Activating...
                                                                                </>
                                                                            ) : (
                                                                                <>
                                                                                    <i className="fa-solid fa-power-off"></i>
                                                                                    Activate Plan
                                                                                </>
                                                                            )}
                                                                        </button>
                                                                    )} */}
                                                                    {paymentTab === "active" && (
                                                                        <button
                                                                            type="button"
                                                                            className="action-btn reminder"
                                                                            onClick={() => SendReminder(payment.username, payment.plan_name, payment.plan_type, payment.plan_status)}
                                                                            title="Send Reminder"
                                                                        >
                                                                            <i className="fa-solid fa-bell"></i>
                                                                        </button>
                                                                    )}
                                                                    {paymentTab === "expired" && (
                                                                        <button
                                                                            type="button"
                                                                            className="action-btn reminder"
                                                                            onClick={() => SendReminder(payment.username, payment.plan_name, payment.plan_type, payment.plan_status)}
                                                                            title="Send Reminder"
                                                                        >
                                                                            <i className="fa-solid fa-bell"></i>
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            </td>

                                                        </tr>
                                                    )
                                                )
                                            )
                                        ) : users.length ===
                                            0 ? (
                                            <tr>
                                                <td colSpan="11">
                                                    No Data Found
                                                </td>
                                            </tr>
                                        ) : (
                                            users.map(
                                                (user) => (
                                                    <tr
                                                        key={
                                                            user.id ||
                                                            user.username
                                                        }
                                                    >

                                                        {activeTab ===
                                                            "existing" ? (
                                                            <>
                                                                <td
                                                                    className="user-name-clickable"
                                                                    style={{
                                                                        textTransform:
                                                                            "capitalize",
                                                                        color: "#242277bb",
                                                                        fontWeight:
                                                                            "800"
                                                                    }}
                                                                    onClick={() =>
                                                                        handleEditUser(
                                                                            user
                                                                        )
                                                                    }
                                                                    title="Click to edit user"
                                                                >
                                                                    {
                                                                        user.fullname
                                                                    }
                                                                </td>

                                                                <td>
                                                                    {
                                                                        user.username
                                                                    }
                                                                </td>

                                                                <td>
                                                                    {
                                                                        user.email
                                                                    }
                                                                </td>

                                                                <td>
                                                                    {
                                                                        user.mobile
                                                                    }
                                                                </td>

                                                                <td>
                                                                    {
                                                                        user.city
                                                                    }
                                                                </td>

                                                                <td>
                                                                    {
                                                                        user.address
                                                                    }
                                                                </td>

                                                                <td>
                                                                    {
                                                                        user.pincode
                                                                    }
                                                                </td>

                                                                <td>
                                                                    {formatDate(
                                                                        user.created_at
                                                                    )}
                                                                </td>

                                                                <td>
                                                                    <span
                                                                        className={`status-badge ${(
                                                                            user.status ||
                                                                            ""
                                                                        ).toLowerCase()}`}
                                                                    >
                                                                        <span className="badge-dot"></span>
                                                                        {
                                                                            user.status
                                                                        }
                                                                    </span>
                                                                </td>

                                                                {/* =================================================
                                                                    BROADBAND PAYMENT STATUS
                                                                ================================================= */}
                                                                <td>
                                                                    {renderBroadbandPaymentStatus(
                                                                        user.username
                                                                    )}
                                                                </td>

                                                                <td className="d-flex justify-content-center align-items-center gap-2">
                                                                    {user.role == "admin"
                                                                        ? ""
                                                                        : (
                                                                            <span
                                                                                className="action-btn delete"
                                                                                onClick={() =>
                                                                                    deleteUser(
                                                                                        user.username
                                                                                    )
                                                                                }
                                                                                title="Delete User"
                                                                            >
                                                                                <i className="fa-solid fa-trash-can"></i>
                                                                            </span>
                                                                        )}

                                                                    {/* <span
                                                                        className="action-btn reminder"
                                                                        onClick={() =>
                                                                            SendReminder(
                                                                                user.username,
                                                                                payments.plan_name,
                                                                                payments.plan_type,
                                                                                payments.plan_status
                                                                            )
                                                                        }
                                                                        title="Send Reminder"
                                                                    >
                                                                        <i className="fa-solid fa-bell"></i>
                                                                    </span> */}

                                                                </td>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <td
                                                                    style={{
                                                                        textTransform:
                                                                            "capitalize"
                                                                    }}
                                                                >
                                                                    {
                                                                        user.name
                                                                    }
                                                                </td>

                                                                <td>
                                                                    {
                                                                        user.email
                                                                    }
                                                                </td>

                                                                <td>
                                                                    {
                                                                        user.mobile
                                                                    }
                                                                </td>

                                                                <td>
                                                                    {
                                                                        user.city
                                                                    }
                                                                </td>

                                                                <td>
                                                                    {
                                                                        user.address
                                                                    }
                                                                </td>

                                                                <td>
                                                                    {
                                                                        user.pincode
                                                                    }
                                                                </td>

                                                                <td>
                                                                    {formatDate(
                                                                        user.created_at
                                                                    )}
                                                                </td>

                                                                <td>
                                                                    <span
                                                                        className={`status-badge ${(user.status || "pending").toLowerCase()}`}
                                                                    >
                                                                        <span className="badge-dot"></span>
                                                                        {user.status || "pending"}
                                                                    </span>
                                                                </td>

                                                                <td>
                                                                    {(() => {
                                                                        const registrationState =
                                                                            getRegistrationState(user);

                                                                        return (
                                                                            <span
                                                                                className={`status-badge registration-${registrationState}`}
                                                                            >
                                                                                <span className="badge-dot"></span>
                                                                                {getRegistrationStateLabel(
                                                                                    registrationState
                                                                                )}
                                                                            </span>
                                                                        );
                                                                    })()}
                                                                </td>

                                                                {/* <td>
                                                                    <span
                                                                        className="action-btn delete"
                                                                        onClick={() =>
                                                                            deleteRequestUser(
                                                                                user.id
                                                                            )
                                                                        }
                                                                        title="Delete Request"
                                                                    >
                                                                        <i className="fa-solid fa-trash-can"></i>
                                                                    </span>
                                                                </td> */}
                                                                <td className="d-flex justify-content-center align-items-center gap-2">

                                                                    {(() => {
                                                                        const registrationState =
                                                                            getRegistrationState(user);
                                                                        const requestStatus =
                                                                            String(user.status || "pending").toLowerCase();

                                                                        if (requestStatus === "pending") {
                                                                            return (
                                                                                <span
                                                                                    className="action-btn request-approve"
                                                                                    onClick={() =>
                                                                                        approveRequest(user)
                                                                                    }
                                                                                    title="Approve Request"
                                                                                >
                                                                                    <i className="fa-solid fa-check"></i>
                                                                                </span>
                                                                            );
                                                                        }

                                                                        if (registrationState === "completed") {
                                                                            return (
                                                                                <span
                                                                                    className="action-btn registration-complete"
                                                                                    title="Registration Completed"
                                                                                >
                                                                                    <i className="fa-solid fa-circle-check"></i>
                                                                                </span>
                                                                            );
                                                                        }

                                                                        return (
                                                                            <span
                                                                                className="action-btn registration-mail"
                                                                                onClick={() =>
                                                                                    sendRegistrationMail(user)
                                                                                }
                                                                                title={
                                                                                    registrationState === "expired"
                                                                                        ? "Link Expired - Send New Registration Link"
                                                                                        : registrationState === "sent"
                                                                                            ? "Send Registration Link Again"
                                                                                            : "Send Registration Link"
                                                                                }
                                                                            >
                                                                                <i
                                                                                    className={`fa-solid ${registrationState === "expired"
                                                                                        ? "fa-rotate-right"
                                                                                        : "fa-envelope"
                                                                                        }`}
                                                                                ></i>
                                                                            </span>
                                                                        );
                                                                    })()}

                                                                    <span
                                                                        className="action-btn delete"
                                                                        onClick={() =>
                                                                            deleteRequestUser(user.id)
                                                                        }
                                                                        title="Delete Request"
                                                                    >
                                                                        <i className="fa-solid fa-trash-can"></i>
                                                                    </span>

                                                                </td>
                                                            </>
                                                        )}

                                                    </tr>
                                                )
                                            )
                                        )}

                                    </tbody>

                                </table>

                            </div>

                            <ToastContainer
                                position="top-right"
                                autoClose={5000}
                                hideProgressBar={false}
                                newestOnTop={false}
                                closeOnClick
                                rtl={false}
                                pauseOnFocusLoss
                                draggable
                                pauseOnHover
                                theme="colored"
                            />

                        </div>

                        {/* Pagination */}

                        <div className="pagination">

                            <button
                                onClick={() => {
                                    if (page > 1) {
                                        setPage(prevPage => prevPage - 1);
                                    }
                                }}
                                disabled={page <= 1 || loading}
                                className="pagination-btn"
                            >
                                <i className="fa-solid fa-chevron-left"></i>
                                Previous
                            </button>
                            <span className="page-indicator">
                                Page <strong>{page}</strong>
                            </span>

                            <button
                                onClick={() => {
                                    if (!loading) {
                                        setPage(prevPage => prevPage + 1);
                                    }
                                }}
                                disabled={loading}
                                className="pagination-btn"
                            >
                                Next
                                <i className="fa-solid fa-chevron-right"></i>
                            </button>

                        </div>
                    </>
                )}
            </div>

            {/* =====================================================
                BROADBAND PLAN MODAL
            ===================================================== */}

            {showPlanModal && (
                <div
                    className="management-modal-overlay"
                    onMouseDown={(e) => {
                        if (
                            e.target === e.currentTarget
                        ) {
                            setShowPlanModal(false);
                        }
                    }}
                >

                    <div className="management-modal large">

                        <div className="management-modal-header">

                            <div>
                                <h2>
                                    {editingPlan
                                        ? "Edit Broad Band Plan"
                                        : "Add Broad Band Plan"}
                                </h2>

                                <p>
                                    Configure plan details,
                                    durations and features.
                                </p>
                            </div>

                            <button
                                className="modal-close-btn"
                                onClick={() =>
                                    setShowPlanModal(
                                        false
                                    )
                                }
                            >
                                <i className="fa-solid fa-xmark"></i>
                            </button>

                        </div>

                        <div className="management-modal-body">

                            <div className="form-grid">

                                <div className={`form-field${planErrors.plan_name ? " has-error" : ""}`}>
                                    <label>
                                        Plan Name *
                                    </label>

                                    <input
                                        value={
                                            planForm.plan_name
                                        }
                                        onChange={(e) =>
                                            updatePlanField(
                                                "plan_name",
                                                e.target.value
                                            )
                                        }
                                        placeholder="50 Mbps Plan"
                                    />
                                    {planErrors.plan_name && (
                                        <span className="field-error-msg">
                                            {planErrors.plan_name}
                                        </span>
                                    )}
                                </div>

                                <div className={`form-field${planErrors.speed ? " has-error" : ""}`}>
                                    <label>
                                        Speed (Mbps) *
                                    </label>

                                    <input
                                        type="number"
                                        min="1"
                                        value={
                                            planForm.speed
                                        }
                                        onChange={(e) =>
                                            updatePlanField(
                                                "speed",
                                                e.target.value
                                            )
                                        }
                                        placeholder="50"
                                    />
                                    {planErrors.speed && (
                                        <span className="field-error-msg">
                                            {planErrors.speed}
                                        </span>
                                    )}
                                </div>

                                <div className="form-field full">
                                    <label>
                                        Tagline
                                    </label>

                                    <input
                                        value={
                                            planForm.tagline
                                        }
                                        onChange={(e) =>
                                            updatePlanField(
                                                "tagline",
                                                e.target.value
                                            )
                                        }
                                        placeholder="Great for families & WFH"
                                    />
                                </div>

                                <div className="form-field">
                                    <label>
                                        Display Order
                                    </label>

                                    <input
                                        type="number"
                                        min="0"
                                        value={
                                            planForm.display_order
                                        }
                                        onChange={(e) =>
                                            updatePlanField(
                                                "display_order",
                                                e.target.value
                                            )
                                        }
                                    />
                                </div>

                                <div className="form-checkboxes">

                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={
                                                planForm.is_popular
                                            }
                                            onChange={(e) =>
                                                updatePlanField(
                                                    "is_popular",
                                                    e.target.checked
                                                )
                                            }
                                        />
                                        Popular Plan
                                    </label>

                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={
                                                planForm.active
                                            }
                                            onChange={(e) =>
                                                updatePlanField(
                                                    "active",
                                                    e.target.checked
                                                )
                                            }
                                        />
                                        Active
                                    </label>

                                </div>

                            </div>

                            {/* Durations */}

                            <div className="form-section">

                                <div className="form-section-header">

                                    <div>
                                        <h3>
                                            Plan Durations
                                        </h3>

                                        <p>
                                            Add different
                                            durations and prices.
                                        </p>
                                    </div>

                                    <button
                                        className="small-primary-btn"
                                        onClick={
                                            addDuration
                                        }
                                    >
                                        <i className="fa-solid fa-plus"></i>
                                        Add Duration
                                    </button>

                                </div>

                                <div className="dynamic-form-list">

                                    {planForm.durations.map(
                                        (
                                            duration,
                                            index
                                        ) => {
                                            const durErr = durationErrors[index] || {};
                                            return (
                                                <div
                                                    className={`dynamic-form-row${(durErr.months || durErr.price) ? " row-has-error" : ""}`}
                                                    key={index}
                                                >

                                                    <div className={`form-field${durErr.months ? " has-error" : ""}`}>
                                                        <label>
                                                            Months *
                                                        </label>

                                                        <input
                                                            type="number"
                                                            min="1"
                                                            value={
                                                                duration.months
                                                            }
                                                            onChange={(
                                                                e
                                                            ) =>
                                                                updateDuration(
                                                                    index,
                                                                    "months",
                                                                    e
                                                                        .target
                                                                        .value
                                                                )
                                                            }
                                                        />
                                                        {durErr.months && (
                                                            <span className="field-error-msg">Required</span>
                                                        )}
                                                    </div>

                                                    <div className="form-field">
                                                        <label>
                                                            Label
                                                        </label>

                                                        <input
                                                            value={
                                                                duration.duration_label
                                                            }
                                                            onChange={(
                                                                e
                                                            ) =>
                                                                updateDuration(
                                                                    index,
                                                                    "duration_label",
                                                                    e
                                                                        .target
                                                                        .value
                                                                )
                                                            }
                                                            placeholder="1 Month"
                                                        />
                                                    </div>

                                                    <div className={`form-field${durErr.price ? " has-error" : ""}`}>
                                                        <label>
                                                            Price *
                                                        </label>

                                                        <input
                                                            type="number"
                                                            min="0"
                                                            value={
                                                                duration.price
                                                            }
                                                            onChange={(
                                                                e
                                                            ) =>
                                                                updateDuration(
                                                                    index,
                                                                    "price",
                                                                    e
                                                                        .target
                                                                        .value
                                                                )
                                                            }
                                                            placeholder="599"
                                                        />
                                                        {durErr.price && (
                                                            <span className="field-error-msg">Valid price required</span>
                                                        )}
                                                    </div>

                                                    <div className="form-field">
                                                        <label>
                                                            Badge
                                                        </label>

                                                        <input
                                                            value={
                                                                duration.badge
                                                            }
                                                            onChange={(
                                                                e
                                                            ) =>
                                                                updateDuration(
                                                                    index,
                                                                    "badge",
                                                                    e
                                                                        .target
                                                                        .value
                                                                )
                                                            }
                                                            placeholder="Best Value"
                                                        />
                                                    </div>

                                                    <button
                                                        className="dynamic-delete-btn"
                                                        onClick={() =>
                                                            removeDuration(
                                                                index
                                                            )
                                                        }
                                                        disabled={
                                                            planForm
                                                                .durations
                                                                .length ===
                                                            1
                                                        }
                                                    >
                                                        <i className="fa-solid fa-trash"></i>
                                                    </button>

                                                </div>
                                            );
                                        }
                                    )}

                                </div>

                            </div>

                            {/* Features */}

                            <div className="form-section">

                                <div className="form-section-header">

                                    <div>
                                        <h3>
                                            Plan Features
                                        </h3>

                                        <p>
                                            Add features that
                                            will be displayed
                                            to users.
                                        </p>
                                    </div>

                                    <button
                                        className="small-primary-btn"
                                        onClick={
                                            addFeature
                                        }
                                    >
                                        <i className="fa-solid fa-plus"></i>
                                        Add Feature
                                    </button>

                                </div>

                                <div className="feature-form-list">

                                    {planForm.features.map(
                                        (
                                            feature,
                                            index
                                        ) => (
                                            <div
                                                className="feature-form-row"
                                                key={
                                                    index
                                                }
                                            >

                                                <i className="fa-solid fa-check"></i>

                                                <input
                                                    value={
                                                        feature
                                                    }
                                                    onChange={(
                                                        e
                                                    ) =>
                                                        updateFeature(
                                                            index,
                                                            e
                                                                .target
                                                                .value
                                                        )
                                                    }
                                                    placeholder="Committed speed on Wi-Fi Router"
                                                />

                                                <button
                                                    className="dynamic-delete-btn"
                                                    onClick={() =>
                                                        removeFeature(
                                                            index
                                                        )
                                                    }
                                                    disabled={
                                                        planForm
                                                            .features
                                                            .length ===
                                                        1
                                                    }
                                                >
                                                    <i className="fa-solid fa-xmark"></i>
                                                </button>

                                            </div>
                                        )
                                    )}

                                </div>

                            </div>

                        </div>

                        <div className="management-modal-footer">

                            <button
                                className="modal-secondary-btn"
                                onClick={() =>
                                    setShowPlanModal(
                                        false
                                    )
                                }
                            >
                                Cancel
                            </button>

                            <button
                                className="modal-primary-btn"
                                onClick={
                                    saveBroadbandPlan
                                }
                            >
                                <i className="fa-solid fa-floppy-disk"></i>

                                {editingPlan
                                    ? "Update Plan"
                                    : "Save Plan"}
                            </button>

                        </div>

                    </div>
                </div>
            )}

            {/* =====================================================
                OTT PLATFORM MODAL
            ===================================================== */}

            {showOttModal && (
                <div className="management-modal-overlay">
                    {ottSaving && (
                        <div className="ott-saving-overlay">
                            <div className="ott-saving-loader">
                                <i className="fa-solid fa-spinner fa-spin"></i>
                                <span>
                                    {editingOtt
                                        ? "Updating OTT..."
                                        : "Uploading OTT logo..."}
                                </span>
                            </div>
                        </div>
                    )}

                    <div className="management-modal">

                        <div className="management-modal-header">

                            <div>
                                <h2>
                                    {editingOtt
                                        ? "Edit OTT Platform"
                                        : "Add OTT Platform"}
                                </h2>

                                <p>
                                    Manage OTT platform
                                    information.
                                </p>
                            </div>

                            <button
                                className="modal-close-btn"
                                onClick={() =>
                                    setShowOttModal(
                                        false
                                    )
                                }
                            >
                                <i className="fa-solid fa-xmark"></i>
                            </button>

                        </div>

                        <div className="management-modal-body">

                            <div className={`form-field${ottErrors.ott_name ? " has-error" : ""}`}>
                                <label>
                                    OTT Name *
                                </label>

                                <input
                                    value={
                                        ottForm.ott_name
                                    }
                                    onChange={(e) => {
                                        setOttForm(
                                            (prev) => ({
                                                ...prev,
                                                ott_name:
                                                    e.target
                                                        .value
                                            })
                                        );
                                        if (ottErrors.ott_name) {
                                            setOttErrors({});
                                        }
                                    }}
                                    placeholder="Netflix"
                                />
                                {ottErrors.ott_name && (
                                    <span className="field-error-msg">
                                        {ottErrors.ott_name}
                                    </span>
                                )}
                            </div>

                            {/* <div className="form-field">
                                <label>
                                    Logo URL
                                </label>

                                <input
                                    value={
                                        ottForm.logo
                                    }
                                    onChange={(e) =>
                                        setOttForm(
                                            (prev) => ({
                                                ...prev,
                                                logo: e
                                                    .target
                                                    .value
                                            })
                                        )
                                    }
                                    placeholder="https://..."
                                />
                            </div>

                            {ottForm.logo && (
                                <div className="logo-preview">
                                    <span>
                                        Logo Preview
                                    </span>

                                    <img
                                        src={
                                            ottForm.logo
                                        }
                                        alt="OTT Preview"
                                        onError={(e) => {
                                            e.currentTarget.style.display =
                                                "none";
                                        }}
                                    />
                                </div>
                            )} */}
                            {/* =========================
    OTT LOGO
========================= */}

                            <div className="ott-logo-section">

                                {/* Logo URL */}

                                <div className="form-field">

                                    <label>
                                        Logo URL
                                    </label>

                                    <input
                                        type="url"
                                        value={ottForm.logo}
                                        onChange={(e) => {
                                            setOttForm((prev) => ({
                                                ...prev,
                                                logo: e.target.value
                                            }));

                                            if (e.target.value) {
                                                setOttLogoPreview(
                                                    e.target.value
                                                );
                                            }
                                        }}
                                        placeholder="https://example.com/netflix.png"
                                    />

                                    <small className="form-help-text">
                                        You can provide an external logo URL
                                        or upload an image below.
                                    </small>

                                </div>


                                {/* OR */}

                                <div className="logo-or-divider">
                                    <span>OR</span>
                                </div>


                                {/* File Upload */}

                                <div className="form-field">

                                    <label>
                                        Upload Logo
                                    </label>

                                    <div className="logo-upload-box">

                                        <input
                                            id="ott-logo-file"
                                            type="file"
                                            accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                                            onChange={handleOttLogoChange}
                                        />

                                        <label
                                            htmlFor="ott-logo-file"
                                            className="logo-upload-label"
                                        >
                                            <i className="fa-solid fa-cloud-arrow-up"></i>

                                            <span>
                                                Choose Logo Image
                                            </span>

                                            <small>
                                                JPG, JPEG or PNG only
                                            </small>
                                        </label>

                                    </div>

                                    {ottForm.logo_file && (
                                        <div className="selected-file-name">
                                            <i className="fa-solid fa-image"></i>

                                            {ottForm.logo_file.name}
                                        </div>
                                    )}

                                </div>


                                {/* Preview */}

                                {ottLogoPreview && (
                                    <div className="logo-preview">

                                        <span>
                                            Logo Preview
                                        </span>

                                        <div className="logo-preview-image">

                                            <img
                                                src={ottLogoPreview}
                                                alt="OTT Logo Preview"
                                                onError={() => {
                                                    setOttLogoPreview("");
                                                }}
                                            />

                                        </div>

                                    </div>
                                )}

                            </div>

                            <div className="form-grid">

                                <div className="form-field">
                                    <label>
                                        Display Order
                                    </label>

                                    <input
                                        type="number"
                                        min="0"
                                        value={
                                            ottForm.display_order
                                        }
                                        onChange={(e) =>
                                            setOttForm(
                                                (prev) => ({
                                                    ...prev,
                                                    display_order:
                                                        e
                                                            .target
                                                            .value
                                                })
                                            )
                                        }
                                    />
                                </div>

                                <div className="form-checkboxes">

                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={
                                                ottForm.active
                                            }
                                            onChange={(e) =>
                                                setOttForm(
                                                    (prev) => ({
                                                        ...prev,
                                                        active:
                                                            e
                                                                .target
                                                                .checked
                                                    })
                                                )
                                            }
                                        />

                                        Active
                                    </label>

                                </div>

                            </div>

                        </div>

                        <div className="management-modal-footer">

                            <button
                                className="modal-secondary-btn"
                                onClick={() =>
                                    setShowOttModal(
                                        false
                                    )
                                }
                            >
                                Cancel
                            </button>

                            {/* <button
                                className="modal-primary-btn"
                                onClick={
                                    saveOttPlatform
                                }
                            >
                                <i className="fa-solid fa-floppy-disk"></i>

                                {editingOtt
                                    ? "Update OTT"
                                    : "Save OTT"}
                            </button> */}
                            <button
                                className="modal-primary-btn"
                                onClick={saveOttPlatform}
                                disabled={ottSaving}
                            >
                                {ottSaving ? (
                                    <>
                                        <i className="fa-solid fa-spinner fa-spin"></i>
                                        Saving...
                                    </>
                                ) : (
                                    <>
                                        <i className="fa-solid fa-floppy-disk"></i>
                                        {editingOtt ? "Update OTT" : "Save OTT"}
                                    </>
                                )}
                            </button>

                        </div>

                    </div>
                </div>
            )}

            {/* =====================================================
                OTT ASSIGNMENT MODAL
            ===================================================== */}

            {showOttAssignmentModal && (
                <div className="management-modal-overlay">

                    <div className="management-modal large">

                        <div className="management-modal-header">

                            <div>
                                <h2>
                                    Manage OTTs
                                </h2>

                                <p>
                                    {selectedPlanForOtt?.plan_name}
                                </p>
                            </div>

                            <button
                                className="modal-close-btn"
                                onClick={() =>
                                    setShowOttAssignmentModal(
                                        false
                                    )
                                }
                            >
                                <i className="fa-solid fa-xmark"></i>
                            </button>

                        </div>

                        <div className="management-modal-body">

                            <div className="duration-selection-box">

                                <span>
                                    Select Duration
                                </span>

                                <div className="ott-duration-pills">

                                    {selectedPlanForOtt?.durations?.map(
                                        (
                                            duration
                                        ) => (
                                            <button
                                                key={
                                                    duration.id
                                                }
                                                type="button"
                                                className={`ott-duration-pill ${selectedDuration?.id ===
                                                    duration.id
                                                    ? "active"
                                                    : ""
                                                    }`}
                                                onClick={() =>
                                                    openOttAssignment(
                                                        selectedPlanForOtt,
                                                        duration
                                                    )
                                                }
                                            >
                                                {
                                                    duration.label
                                                }
                                            </button>
                                        )
                                    )}

                                </div>

                            </div>

                            <div className="assignment-summary">

                                <div>
                                    <span>
                                        Selected Duration
                                    </span>

                                    <strong>
                                        {
                                            selectedDuration?.label
                                        }
                                    </strong>
                                </div>

                                <div>
                                    <span>
                                        Selected OTTs
                                    </span>

                                    <strong>
                                        {
                                            selectedOttIds.length
                                        }
                                    </strong>
                                </div>

                            </div>

                            {ottLoading ? (
                                <div className="modal-loading">
                                    Loading OTT platforms...
                                </div>
                            ) : (
                                <div className="ott-assignment-grid">

                                    {ottPlatforms
                                        .filter(
                                            (ott) =>
                                                Number(
                                                    ott.active
                                                ) === 1
                                        )
                                        .map((ott) => {

                                            const selected =
                                                selectedOttIds.includes(
                                                    Number(
                                                        ott.id
                                                    )
                                                );

                                            return (
                                                <button
                                                    type="button"
                                                    key={
                                                        ott.id
                                                    }
                                                    className={`ott-assignment-card ${selected
                                                        ? "selected"
                                                        : ""
                                                        }`}
                                                    onClick={() =>
                                                        toggleSelectedOtt(
                                                            ott.id
                                                        )
                                                    }
                                                >

                                                    <div className="assignment-logo">

                                                        {ott.logo ? (
                                                            <img
                                                                src={
                                                                    ott.logo
                                                                }
                                                                alt={
                                                                    ott.ott_name
                                                                }
                                                            />
                                                        ) : (
                                                            <i className="fa-solid fa-tv"></i>
                                                        )}

                                                    </div>

                                                    <span>
                                                        {
                                                            ott.ott_name
                                                        }
                                                    </span>

                                                    <i
                                                        className={`fa-solid ${selected
                                                            ? "fa-circle-check"
                                                            : "fa-circle-plus"
                                                            }`}
                                                    ></i>

                                                </button>
                                            );
                                        })}

                                </div>
                            )}

                        </div>

                        <div className="management-modal-footer">

                            <button
                                className="modal-secondary-btn"
                                onClick={() =>
                                    setShowOttAssignmentModal(
                                        false
                                    )
                                }
                            >
                                Cancel
                            </button>

                            <button
                                className="modal-primary-btn"
                                onClick={
                                    saveOttAssignments
                                }
                                disabled={ottLoading}
                            >
                                <i className="fa-solid fa-floppy-disk"></i>
                                Save OTT Configuration
                            </button>

                        </div>

                    </div>
                </div>
            )}

            {/* =====================================================
                OTT ADD-ON PLAN ASSIGNMENT MODAL
            ===================================================== */}

            {showAddonOttAssignmentModal && (
                <div className="management-modal-overlay">

                    <div className="management-modal large">

                        <div className="management-modal-header">

                            <div>
                                <h2>
                                    Manage OTT Plans
                                </h2>

                                <p>
                                    Select the OTT platforms included in
                                    {" "}
                                    {selectedAddonForOtt?.duration_label || "this add-on plan"}.
                                </p>
                            </div>

                            <button
                                className="modal-close-btn"
                                onClick={() =>
                                    setShowAddonOttAssignmentModal(false)
                                }
                            >
                                <i className="fa-solid fa-xmark"></i>
                            </button>

                        </div>

                        <div className="management-modal-body">

                            <div className="assignment-summary">
                                <div>
                                    <span>
                                        Add-on Plan
                                    </span>

                                    <strong>
                                        {selectedAddonForOtt?.duration_label || "-"}
                                    </strong>
                                </div>

                                <div>
                                    <span>
                                        Selected OTTs
                                    </span>

                                    <strong>
                                        {selectedAddonOttIds.length}
                                    </strong>
                                </div>
                            </div>

                            {addonOttLoading ? (
                                <div className="modal-loading">
                                    Loading OTT platforms...
                                </div>
                            ) : (
                                <div className="ott-assignment-grid">

                                    {ottPlatforms
                                        .filter(
                                            (ott) =>
                                                Number(ott.active) === 1
                                        )
                                        .map((ott) => {
                                            const ottId =
                                                Number(ott.id);

                                            const selected =
                                                selectedAddonOttIds.includes(
                                                    ottId
                                                );

                                            return (
                                                <button
                                                    type="button"
                                                    key={ott.id}
                                                    className={`ott-assignment-card ${selected ? "selected" : ""}`}
                                                    onMouseDown={(e) =>
                                                        e.preventDefault()
                                                    }
                                                    onClick={() =>
                                                        toggleSelectedAddonOtt(
                                                            ottId
                                                        )
                                                    }
                                                >
                                                    <div className="assignment-logo">
                                                        {ott.logo ? (
                                                            <img
                                                                src={ott.logo}
                                                                alt={ott.ott_name}
                                                            />
                                                        ) : (
                                                            <i className="fa-solid fa-tv"></i>
                                                        )}
                                                    </div>

                                                    <span>
                                                        {ott.ott_name}
                                                    </span>

                                                    <i
                                                        className={`fa-solid ${selected
                                                            ? "fa-circle-check"
                                                            : "fa-circle-plus"
                                                            }`}
                                                    ></i>
                                                </button>
                                            );
                                        })}

                                </div>
                            )}

                        </div>

                        <div className="management-modal-footer">

                            <button
                                className="modal-secondary-btn"
                                onClick={() =>
                                    setShowAddonOttAssignmentModal(false)
                                }
                            >
                                Cancel
                            </button>

                            <button
                                className="modal-primary-btn"
                                onClick={saveAddonOttAssignments}
                                disabled={addonOttLoading}
                            >
                                <i className="fa-solid fa-floppy-disk"></i>
                                Save OTT Configuration
                            </button>

                        </div>

                    </div>
                </div>
            )}

            {/* =====================================================
                OTT ADDON MODAL
            ===================================================== */}

            {showAddonModal && (
                <div className="management-modal-overlay">

                    <div className="management-modal large">

                        <div className="management-modal-header">

                            <div>
                                <h2>
                                    {editingAddon
                                        ? "Edit OTT Add-on Plan"
                                        : "Add OTT Add-on Plan"}
                                </h2>

                                <p>
                                    Configure OTT-only
                                    subscription plans.
                                </p>
                            </div>

                            <button
                                className="modal-close-btn"
                                onClick={() =>
                                    setShowAddonModal(
                                        false
                                    )
                                }
                            >
                                <i className="fa-solid fa-xmark"></i>
                            </button>

                        </div>

                        <div className="management-modal-body">

                            <div className="form-grid">

                                <div className={`form-field${addonErrors.duration_months ? " has-error" : ""}`}>
                                    <label>
                                        Duration Months *
                                    </label>

                                    <input
                                        type="number"
                                        min="1"
                                        value={
                                            addonForm.duration_months
                                        }
                                        onChange={(e) =>
                                            updateAddonField(
                                                "duration_months",
                                                e.target.value
                                            )
                                        }
                                    />
                                    {addonErrors.duration_months && (
                                        <span className="field-error-msg">
                                            {addonErrors.duration_months}
                                        </span>
                                    )}
                                </div>

                                <div className={`form-field${addonErrors.duration_label ? " has-error" : ""}`}>
                                    <label>
                                        Duration Label *
                                    </label>

                                    <input
                                        value={
                                            addonForm.duration_label
                                        }
                                        onChange={(e) =>
                                            updateAddonField(
                                                "duration_label",
                                                e.target.value
                                            )
                                        }
                                        placeholder="3 Months"
                                    />
                                    {addonErrors.duration_label && (
                                        <span className="field-error-msg">
                                            {addonErrors.duration_label}
                                        </span>
                                    )}
                                </div>

                                <div className={`form-field${addonErrors.price ? " has-error" : ""}`}>
                                    <label>
                                        Price *
                                    </label>

                                    <input
                                        type="number"
                                        min="0"
                                        value={
                                            addonForm.price
                                        }
                                        onChange={(e) =>
                                            updateAddonField(
                                                "price",
                                                e.target.value
                                            )
                                        }
                                        placeholder="449"
                                    />
                                    {addonErrors.price && (
                                        <span className="field-error-msg">
                                            {addonErrors.price}
                                        </span>
                                    )}
                                </div>

                                <div className="form-field">
                                    <label>
                                        Badge
                                    </label>

                                    <input
                                        value={
                                            addonForm.badge
                                        }
                                        onChange={(e) =>
                                            updateAddonField(
                                                "badge",
                                                e.target.value
                                            )
                                        }
                                        placeholder="BEST VALUE"
                                    />
                                </div>

                                <div className="form-field">
                                    <label>
                                        Display Order
                                    </label>

                                    <input
                                        type="number"
                                        min="0"
                                        value={
                                            addonForm.display_order
                                        }
                                        onChange={(e) =>
                                            updateAddonField(
                                                "display_order",
                                                e.target.value
                                            )
                                        }
                                    />
                                </div>

                                <div className="form-checkboxes">

                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={
                                                addonForm.is_popular
                                            }
                                            onChange={(e) =>
                                                updateAddonField(
                                                    "is_popular",
                                                    e.target
                                                        .checked
                                                )
                                            }
                                        />
                                        Popular
                                    </label>

                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={
                                                addonForm.active
                                            }
                                            onChange={(e) =>
                                                updateAddonField(
                                                    "active",
                                                    e.target
                                                        .checked
                                                )
                                            }
                                        />
                                        Active
                                    </label>

                                </div>

                                <div className="form-field full">

                                    <label>
                                        Description
                                    </label>

                                    <textarea
                                        value={
                                            addonForm.description
                                        }
                                        onChange={(e) =>
                                            updateAddonField(
                                                "description",
                                                e.target.value
                                            )
                                        }
                                        placeholder="29 OTT Platforms with premium entertainment"
                                        rows="3"
                                    />

                                </div>

                            </div>

                            <div className="form-section">

                                <div className="form-section-header">

                                    <div>
                                        <h3>
                                            Add-on Features
                                        </h3>

                                        <p>
                                            Features shown on
                                            the OTT add-on card.
                                        </p>
                                    </div>

                                    <button
                                        className="small-primary-btn"
                                        onClick={
                                            addAddonFeature
                                        }
                                    >
                                        <i className="fa-solid fa-plus"></i>
                                        Add Feature
                                    </button>

                                </div>

                                <div className="feature-form-list">

                                    {addonForm.features.map(
                                        (
                                            feature,
                                            index
                                        ) => (
                                            <div
                                                className="feature-form-row"
                                                key={
                                                    index
                                                }
                                            >

                                                <i className="fa-solid fa-check"></i>

                                                <input
                                                    value={
                                                        feature
                                                    }
                                                    onChange={(
                                                        e
                                                    ) =>
                                                        updateAddonFeature(
                                                            index,
                                                            e
                                                                .target
                                                                .value
                                                        )
                                                    }
                                                    placeholder="29 OTT Platforms"
                                                />

                                                <button
                                                    className="dynamic-delete-btn"
                                                    onClick={() =>
                                                        removeAddonFeature(
                                                            index
                                                        )
                                                    }
                                                    disabled={
                                                        addonForm
                                                            .features
                                                            .length ===
                                                        1
                                                    }
                                                >
                                                    <i className="fa-solid fa-xmark"></i>
                                                </button>

                                            </div>
                                        )
                                    )}

                                </div>

                            </div>

                        </div>

                        <div className="management-modal-footer">

                            <button
                                className="modal-secondary-btn"
                                onClick={() =>
                                    setShowAddonModal(
                                        false
                                    )
                                }
                            >
                                Cancel
                            </button>

                            <button
                                className="modal-primary-btn"
                                onClick={
                                    saveAddonPlan
                                }
                            >
                                <i className="fa-solid fa-floppy-disk"></i>

                                {editingAddon
                                    ? "Update Add-on"
                                    : "Save Add-on"}
                            </button>

                        </div>

                    </div>
                </div>
            )}

            {/* Register Modal */}
            {showRegisterModal && (
                <RegisterModal
                    onClose={(success) => {
                        setShowRegisterModal(false);
                        if (success === true) {
                            fetchData();
                        }
                    }}
                />
            )}

            {showEditModal && (

                <div className="edit-user-overlay">

                    <div className="edit-user-modal">

                        <div className="edit-user-header">

                            <div>
                                <h2>Edit User</h2>

                                <p>
                                    Update the existing user details
                                </p>
                            </div>

                            <button
                                type="button"
                                className="edit-user-close"
                                onClick={() => {
                                    setShowEditModal(false);
                                    setEditingUser(null);
                                }}
                            >
                                ×
                            </button>

                        </div>


                        <form
                            onSubmit={handleUpdateUser}
                            className="edit-user-form"
                        >


                            {/* FULL NAME */}

                            <div className="edit-form-group">

                                <label>
                                    Full Name *
                                </label>

                                <input
                                    type="text"
                                    name="fullname"
                                    value={editForm.fullname}
                                    onChange={handleEditChange}
                                    required
                                />

                            </div>


                            {/* USERNAME */}

                            <div className="edit-form-group">

                                <label>
                                    Username *
                                </label>

                                <input
                                    type="text"
                                    name="username"
                                    value={editForm.username}
                                    onChange={handleEditChange}
                                    required
                                />

                            </div>


                            {/* EMAIL */}

                            <div className="edit-form-group">

                                <label>
                                    Email *
                                </label>

                                <input
                                    type="email"
                                    name="email"
                                    value={editForm.email}
                                    onChange={handleEditChange}
                                    required
                                />

                            </div>

                            {/* PASSWORD */}

                            <div className="edit-form-group">

                                <label>
                                    Password
                                </label>

                                <div style={{ position: 'relative' }}>
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        name="password"
                                        value={editForm.password}
                                        onChange={handleEditChange}
                                        placeholder="Enter new password"
                                        autoComplete="new-password"
                                        style={{ paddingRight: '40px' }}
                                    />
                                    <button
                                        type="button"
                                        onClick={() => setShowPassword(!showPassword)}
                                        style={{
                                            position: 'absolute',
                                            right: '12px',
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            background: 'none',
                                            border: 'none',
                                            cursor: 'pointer',
                                            color: '#64748b',
                                            display: 'flex',
                                            alignItems: 'center',
                                            padding: 0
                                        }}
                                        title={showPassword ? "Hide password" : "Show password"}
                                    >
                                        {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                    </button>
                                </div>

                                <small>
                                    Enter a new password only if you want to change it.
                                </small>

                            </div>


                            {/* MOBILE */}

                            <div className="edit-form-group">

                                <label>
                                    Mobile Number
                                </label>

                                <input
                                    type="text"
                                    name="mobile"
                                    value={editForm.mobile}
                                    onChange={handleEditChange}
                                />

                            </div>


                            {/* CITY */}

                            <div className="edit-form-group">

                                <label>
                                    City
                                </label>

                                <input
                                    type="text"
                                    name="city"
                                    value={editForm.city}
                                    onChange={handleEditChange}
                                />

                            </div>


                            {/* ADDRESS */}

                            <div className="edit-form-group">

                                <label>
                                    Address
                                </label>

                                <textarea
                                    name="address"
                                    value={editForm.address}
                                    onChange={handleEditChange}
                                    rows="3"
                                />

                            </div>


                            {/* PINCODE */}

                            <div className="edit-form-group">

                                <label>
                                    Pincode
                                </label>

                                <input
                                    type="text"
                                    name="pincode"
                                    value={editForm.pincode}
                                    onChange={handleEditChange}
                                />

                            </div>


                            {/* BUTTONS */}

                            <div className="edit-user-actions">

                                <button
                                    type="button"
                                    className="edit-cancel-btn"
                                    onClick={() => {
                                        setShowEditModal(false);
                                        setEditingUser(null);
                                    }}
                                    disabled={updatingUser}
                                >
                                    Cancel
                                </button>


                                <button
                                    type="submit"
                                    className="edit-save-btn"
                                    disabled={updatingUser}
                                >

                                    {updatingUser
                                        ? "Saving..."
                                        : "Save Changes"
                                    }

                                </button>

                            </div>

                        </form>

                    </div>

                </div>

            )}
        </>
    );
}

export default Adminpage;